import { Component, OnInit, Inject, HostListener, ViewEncapsulation, ViewChild, ElementRef, NgZone, OnDestroy, ViewContainerRef, TemplateRef, ChangeDetectionStrategy, ChangeDetectorRef} from '@angular/core';
import { UserInterface } from '../models/user';
import { OauthService} from '../service/oauth.service';
import { ViewobserverService } from '../service/viewobserver.service';
import { TelemetryService } from '../service/telemetry.service';
import { MarkersService } from '../service/markers.service';
import { MarkerInterface } from '../models/marker';
import { AlarmsqueryService } from '../service/alarmsquery.service';
import { GoogleChartInterface} from 'ng2-google-charts/ng2-google-charts';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table'
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BQRequestService } from '../service/bqrequest.service';
import { AppComponent } from '../app.component';
import { Router } from '@angular/router';
import {FormControl, FormGroup, FormBuilder} from '@angular/forms';
import { Observable, of } from 'rxjs';
import { fromEvent, Subscription } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
import { take, filter } from 'rxjs/operators';
import { MatSidenav} from '@angular/material/sidenav';
import { SimplifyAP, ISimplifyArrayPoint} from 'simplify-ts';
import { ma, sma } from 'moving-averages';
import { MatMenuTrigger } from '@angular/material';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';
//import { GoogleChartComponent } from 'angular-google-charts';
//import { google } from '@agm/core/services/google-maps-types';
import {CompactType, DisplayGrid, Draggable, GridsterConfig, GridsterItem, GridType, PushDirections, Resizable} from 'angular-gridster2';
import * as $ from 'jquery';
import { saveAs } from 'file-saver';
import * as moment from 'moment';
import { DaterangepickerDirective } from 'ngx-daterangepicker-material'
import domtoimage from 'dom-to-image';


export interface DialogData {
  city: string;
  office: string;
  model: string;
  name: string;
  zone: string;
  value1?: number;
  value2?: number;
  value3?: number;
  value4?: number;
  chartdata: any;
  devType: string;
  label: string;
  devices: [];
}

interface Safe extends GridsterConfig{
  draggable: Draggable;
  resizable: Resizable;
  pushDirections: PushDirections;
}

@Component({
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Default,
  selector: 'app-cards',
  templateUrl: './cards.component.html',
  styleUrls: ['./cards.component.css']
})
export class CardsComponent implements OnInit, OnDestroy {
  @ViewChild('sideNav', { static: true }) sidenav: MatSidenav;
  @ViewChild('search', { static: false }) searchElementRef: ElementRef;
  options: Safe;
  
  public dashboard: Array<GridsterItem>;
  myNewDims: any;
  myNewDims2: any; 
  public InitialLoadingPromise = Promise.resolve(true); 
  public Spaces = [];
  public Snames = [];
  public TabIndex = ""; //para cambiar entre los diferentes espacios disponibles
  public Devices = [];
  public userUid;
  public dashSubs = [];
  public SpaceLimit = 3;

  public devicesData = new MatTableDataSource;
  public filteredDevices: Observable<any[]>;
  public side_menu_state: boolean = false;

  private marksSub;
  private subObserver;
  private subAlarms;
  private usrSub;
  public updateOnExit: boolean = false;

  public sub: Subscription;
  public interval;
  public intervalTime;

  public date: Date = new Date();

  isMobile: boolean = false;
  markers: MarkerInterface[];

  SearchBarControl = new FormControl();
  // sitesData = new MatTableDataSource(this.markers); //conjunto de datos de lugares GVC
  // filteredSites: Observable<MarkerInterface[]>; //lugares filtrados

 
  user: UserInterface = {
    name: '',
    photoUrl: '',
    isLogged: false,
    email: '',
    roles: { 
      viewer: false,
      admin: false,
    },
  };

  public select(event){
    
  } 

  public GaugeChart: GoogleChartInterface= {
    chartType: 'Gauge',
    dataTable: [
      ['Label', 'Value'],
      ['Value', 22.3]
    ],
    options: {
      animation: {easing: 'out'},
      width: 152, height: 100,
      greenFrom: 13, greenTo: 24,
      yellowFrom: 24, yellowTo: 29,
      redFrom: 29, redTo: 50,
      minorTicks: 5,
      min: 0, max: 40,
      majorTicks: ['0', '10', '20', '30', '40', '50'],
      greenColor: '#d0e9c6'
    }
  }

  redrawfunction(chart){
    let ccComponent = chart.component;
    let ccwrapper = ccComponent.wrapper;

    //redraw
    ccComponent.draw();
  }

  @HostListener('window:resize', ['$event'])
  sizeChange($event){
    this.myNewDims = window.innerHeight - 45;
    this.myNewDims2 = window.innerHeight -88;
    
            
    console.log(this.dashboard, 'event');
    this.cdr.detectChanges();
    // let dummyDash = [];
    // this.dashboard.forEach(element => {
    //   if(element.sub != undefined)
    //     {
    //       element.sub = '';
    //     }
    //   dummyDash.push(element);
    // });
    //this.authService.UpdateUserDashboardMonitoring(this.appComponent.userUid, dummyDash, "0");
  }

  @HostListener('window:beforeunload', [ '$event' ])
  onPageUnload($event: BeforeUnloadEvent) {
    if (this.updateOnExit) {
      $event.returnValue = true;
      this.authService.UpdateUserDashboardMonitoring(this.userUid, this.dashboard, this.Snames.indexOf(this.TabIndex), this.appComponent.selectedProyect['id']);
      this.updateOnExit = false;
      this.snack.open('Cambios Guardados con exito!', '', {duration: 1000})
    }
  }

  @ViewChild('contextMenu', { static: true }) contextMenu: TemplateRef<any>;


  //contextMenuPosition = { x: '0px', y: '0px' };

  overlayRef: OverlayRef | null;

  public doit
  trigger(){
    window.dispatchEvent(new Event('resize'));   
    //actualiza la vista manualmente
    this.cdr.detectChanges(); 
  }

  constructor(private authService: OauthService, 
      private observer: ViewobserverService,
      private markersService: MarkersService,
      private telemetryService: TelemetryService,
      private alarmService: AlarmsqueryService,
      public dialog: MatDialog,
      public appComponent: AppComponent,
      private ngZone: NgZone,
      public snack: MatSnackBar,
      private router: Router,
      public overlay: Overlay,
      public viewContainerRef: ViewContainerRef,
      private cdr: ChangeDetectorRef){
        this.intervalTime = setInterval(() => {
          this.date = new Date();
          //aqui reviso los ultimos datos recibidos
          for(let s in this.dashboard)
          {
            if(this.dashboard[s].widgetType != 'Clock')
            {
              let id = this.dashboard[s].id
              let lastSeen = new Date(this.dashboard[s].lastSeen);
              let timeElapsed = (this.date.getTime() - lastSeen.getTime()) / (1000*60);
              if(timeElapsed > 30){
                document.getElementById(id+'state').style.backgroundColor = 'red';
              }
              else
              {
                document.getElementById(id+'state').style.backgroundColor = 'green';              
              }
            }
          }
        }, 30000);
        
        router.events.subscribe(val =>{ });
      }
  

  ngOnInit() { 
      this.interval = setInterval(() =>{
        this.cdr.detectChanges();
      }, 30);

      this.dashSubs = [];
      // $('body').on('click', function(e) {
      //   this.explode(e.pageX, e.pageY);
      // }, this.explode)
      //-------- Opciones para el gridster --------
      this.options = {
        gridType: GridType.ScrollHorizontal,
        compactType: CompactType.None,
        margin: 10,
        outerMargin: true,
        outerMarginTop: null,
        outerMarginRight: null,
        outerMarginBottom: null,
        outerMarginLeft: null,
        useTransformPositioning: true,
        mobileBreakpoint: 640,
        minCols: 6,
        maxCols: 9,
        minRows: 4,
        maxRows: 4,
        maxItemCols: 100,
        minItemCols: 1,
        maxItemRows: 100,
        minItemRows: 1,
        maxItemArea: 2500,
        minItemArea: 1,
        defaultItemCols: 1,
        defaultItemRows: 1,
        fixedColWidth: 255,
        fixedRowHeight: 250,
        keepFixedHeightInMobile: false,
        keepFixedWidthInMobile: false,
        scrollSensitivity: 10,
        scrollSpeed: 20,
        enableEmptyCellClick: false,
        enableEmptyCellContextMenu: false,
        enableEmptyCellDrop: false,
        enableEmptyCellDrag: false,
        enableOccupiedCellDrop: false,
        emptyCellDragMaxCols: 50,
        emptyCellDragMaxRows: 50,
        ignoreMarginInRow: false,
        draggable: {
          enabled: true,
          stop: function (event, $element, widget) {
            if($element['drag']['lastMouse']['clientX'] != 0 || $element['drag']['lastMouse']['clientY'] != 0)
            {this.updateOnExit = true }
          }.bind(this)
        },
        resizable: {
          enabled: true,
        },
        swap: true,
        pushItems: false,
        disablePushOnDrag: false,
        disablePushOnResize: false,
        pushDirections: {north: true, east: true, south: true, west: true},
        pushResizeItems: false,
        displayGrid: DisplayGrid.OnDragAndResize,
        disableWindowResize: false,
        disableWarnings: false,
        scrollToNewItems: false
      };
      //-------------------------------------------

      this.dashboard = [
        {cols: 2, rows: 1, y: 0, x: 0, dragEnabled: true, widgetType: 'Clock', resizeEnabled: false, minItemCols: 2, label: 'Fecha/Hora Actual'},
        // {cols: 1, rows: 1, y: 1, x: 0, dragEnabled: true, widgetType: 'TempOnly', resizeEnabled: false, label: '', telemetry: '', lastSeen: ''},
        // {cols: 2, rows: 1, y: 0, x: 3, dragEnabled: true, widgetType: 'Energy3P', resizeEnabled: false, label: 'Widget 3', telemetry: {v1: 123, v2: 123, v3: 123, 
        //                                                                                                          i1: 123, i2: 123, i3: 123,
        //                                                                                                          s1: 123, s2: 123, s3: 123,
        //                                                                                                          freq: 60, fp: 0.9}           , lastSeen: null},
        // {cols: 2, rows: 1, y: 0, x: 3, dragEnabled: true, widgetType: 'Energy3P', resizeEnabled: false, label: 'Widget 4', telemetry: {v1: 123, v2: 123, v3: 123, 
        //                                                                                                           i1: 123, i2: 123, i3: 123,
        //                                                                                                           s1: 123, s2: 123, s3: 123,
        //                                                                                                           freq: 60, fp: 0.9}           , lastSeen: null},
        // {cols: 1, rows: 1, y: 1, x: 0, dragEnabled: true, widgetType: 'TempOnly', resizeEnabled: false, label: '', telemetry: '', lastSeen: ''},
        // {cols: 1, rows: 2, y: 3, x: 5, dragEnabled: true, widgetType: 'TempOnlyGraph', resizeEnabled: true, label: '', telemetry: '', lastSeen: ''},
        // {cols: 1, rows: 1, y: 2, x: 1, dragEnabled: true, widgetType: 'Empty', resizeEnabled: true, label: 'Drag&Resize Enabled', telemetry: 50},
        // {cols: 1, rows: 1, y: 4, x: 5, dragEnabled: true, widgetType: 'TempOnlyGauge', resizeEnabled: true, label: '', telemetry: '', lastSeen: ''},
      ];

      this.delay(500).then(any=>{
        
        this.cdr.detach();
        //this.authService.UpdateUserDashboardMonitoring(this.appComponent.userUid, this.dashboard, "Space1");
        // retrieve spaces alias and dashboards by user
        let sub = this.authService.getUserDashboardMonitoring(this.appComponent.userUid).subscribe( data => {
          
          let projID = this.appComponent.selectedProyect['id'];
          if(data['Spaces'] != undefined)
          {
            for(let space in data['Spaces'][projID]){
              this.Spaces.push(data['Spaces'][projID][space])
            }
            for (let Snames in data["SpacesAlias"][projID]){
              this.Snames.push(data["SpacesAlias"][projID][Snames]);
            }
            this.SpaceLimit = data['SpaceLimit'];
            sub.unsubscribe();
            this.TabIndex = this.Snames[0];
            this.dashboard = this.Spaces[0];

            this.InitialLoadingPromise = Promise.resolve(false);//se resuelve la promesa para dibujar el dashboard
            
            //una vez cargado los datos desde Firestore iniciar los subscribe (flujo de datos)
            this.delay(5).then(any =>{              
              for(let s in this.dashboard){
                this.cdr.detectChanges();
                this.dashSubs.push({s: ''});
                //aqui crear los subs
                if (this.dashboard[s].widgetType == 'Clock'){continue} //skip clock widget
                if (this.dashboard[s].widgetType == 'Energy3P'){ //sub for PM widget
                  this.dashSubs[s].s = this.telemetryService.getTelemetry(this.dashboard[s].id).subscribe(result =>{
                    for(let dev in this.Devices)
                    {
                      if(this.Devices[dev].bd_id == this.dashboard[s].id)
                      {
                        let dummy = this.dashboard[s].label.split(' ')[0];
                        this.dashboard[s].label = dummy+' '+this.Devices[dev].alias;
                      }
                    }
                    let dummy = result['timestamp'].split(' ');
                    let dummy2 = dummy[0].split('-');
                    let date = dummy2[0]+'/'+dummy2[2]+'/'+dummy2[1];
                    let fullfixed = date+' '+dummy[1];
                    var d = new Date(fullfixed);
                    this.dashboard[s].lastSeen = result['timestamp'];
                    this.dashboard[s].telemetry.v1 = this.round(result['v1'] ,1);
                    this.dashboard[s].telemetry.v2 = this.round(result['v2'] ,1);
                    this.dashboard[s].telemetry.v3 = this.round(result['v3'] ,1);
                    this.dashboard[s].telemetry.i1 = this.round(result['c1'] ,1);
                    this.dashboard[s].telemetry.i2 = this.round(result['c2'] ,1);
                    this.dashboard[s].telemetry.i3 = this.round(result['c3'] ,1);
                    this.dashboard[s].telemetry.s1 = this.round(result['s1'] ,1);
                    this.dashboard[s].telemetry.s2 = this.round(result['s2'] ,1);
                    this.dashboard[s].telemetry.s3 = this.round(result['s3'] ,1);
                    this.dashboard[s].telemetry.freq = this.round(result['freq'] ,1);
                    this.dashboard[s].telemetry.fp = this.round(result['fp'] ,1);
                    document.getElementById(this.dashboard[s].id+'state').title = 'Ultimo dato: '+result['timestamp'];
                    let lastSeen = new Date(this.dashboard[s].lastSeen);
                    let timeElapsed = (this.date.getTime() - lastSeen.getTime()) / (1000*60);
                    if(timeElapsed > 30)
                    {
                      document.getElementById(this.dashboard[s].id+'state').style.backgroundColor = 'red';
                    }
                    //actualiza manualmente
                    this.cdr.detectChanges();
                  })
                }
                if (this.dashboard[s].widgetType == 'TempOnly'){ //sub for MT simple widget
                  this.dashSubs[s].s = this.telemetryService.getTelemetry(this.dashboard[s].id).subscribe(result =>{
                    for(let dev in this.Devices)
                    {
                      if(this.Devices[dev].bd_id == this.dashboard[s].id)
                      {
                        let dummy = this.dashboard[s].label.split(' ')[0];
                        this.dashboard[s].label = dummy+' '+this.Devices[dev].alias;
                      }
                    }
                    let temp = this.round(result['Temp'] ,1);
                    //update temp and timestamp
                    this.dashboard[s].telemetry = temp;
                    this.dashboard[s].humi = result['Humi'];
                    this.dashboard[s].lastSeen = result['timestamp'];
                    document.getElementById(this.dashboard[s].id+'state').title = 'Ultimo dato: '+result['timestamp'];
                    let lastSeen = new Date(this.dashboard[s].lastSeen);
                    let timeElapsed = (this.date.getTime() - lastSeen.getTime()) / (1000*60);
                    if(timeElapsed > 30)
                    {
                      document.getElementById(this.dashboard[s].id+'state').style.backgroundColor = 'red';
                    }
                    //actualiza la vista manualmente
                    this.cdr.detectChanges();
                  })
                }
                if (this.dashboard[s].widgetType == 'TempOnlyGraph'){ //sub for MT with graph widget
                  //style on the go because why not
                  let elementTStyle = document.head.appendChild(document.createElement("style"));
                  elementTStyle.innerHTML = "#"+this.dashboard[s].id+" {bottom: 0;background: linear-gradient(#f17a65, #3dcadf) no-repeat bottom;width: 102%;border-radius: 20px;background-size: 100%;transition: all 0.2s ease-in-out;position: absolute;}";
                  let elementTStyleTooltip = document.head.appendChild(document.createElement("style"));
                  elementTStyleTooltip.innerHTML = "#"+this.dashboard[s].id+":before {content: attr(data-value);background: rgba(0, 0, 0, 0.7);color: mediumspringgreen;z-index: 2;padding: 5px 10px;border-radius: 5px;font-size: medium;line-height: 1;position: absolute;transform: translateY(50%);left: calc(100% + 1em / 1.5);top: calc(-1em + 5px - 5px * 2);}"
                  let elementTStyleDash = document.head.appendChild(document.createElement("style"));
                  elementTStyleDash.innerHTML = "#"+this.dashboard[s].id+":after {content: '';position: absolute;border-top: 0.4545454545em solid transparent;border-bottom: 0.4545454545em solid transparent;border-right: 0.6666666667em solid rgba(0, 0, 0, 0.7);left: 100%;top: calc(-1em / 2.2 + 5px);}"
                  //end of style on the go
                  this.dashSubs[s].s = this.telemetryService.getTelemetry(this.dashboard[s].id).subscribe(result =>{
                    for(let dev in this.Devices)
                    {
                      if(this.Devices[dev].bd_id == this.dashboard[s].id)
                      {
                        let dummy = this.dashboard[s].label.split(' ')[0];
                        this.dashboard[s].label = dummy+' '+this.Devices[dev].alias;
                      }
                    }
                    let temp = this.round(result['Temp'] ,1);
                    let elementT = document.getElementById(this.dashboard[s].id);
                    
                    elementT.style.height = (temp - -20) / (50 - -20) * 100 + "%";
                    elementT.dataset.value = temp + "°C";
                    //update
                    this.dashboard[s].humi = result['Humi'];
                    //this.dashboard[s].telemetry = (temp - 0) / (100 - 0) * 100;
                    this.dashboard[s].lastSeen = result['timestamp'];
                    document.getElementById(this.dashboard[s].id+'state').title = 'Ultimo dato: '+result['timestamp'];
                    let lastSeen = new Date(this.dashboard[s].lastSeen);
                    let timeElapsed = (this.date.getTime() - lastSeen.getTime()) / (1000*60);
                    if(timeElapsed > 30)
                    {
                      document.getElementById(this.dashboard[s].id+'state').style.backgroundColor = 'red';
                    }
                    //actualiza la vista manualmente
                    this.cdr.detectChanges();
                  })
                }
                if (this.dashboard[s].widgetType == 'TempOnlySGauge'){ //sub for MT with gauge widget
                  this.dashSubs[s].s = this.telemetryService.getTelemetry(this.dashboard[s].id).subscribe(result =>{
                    for(let dev in this.Devices)
                    {
                      if(this.Devices[dev].bd_id == this.dashboard[s].id)
                      {
                        let dummy = this.dashboard[s].label.split(' ')[0];
                        this.dashboard[s].label = dummy+' '+this.Devices[dev].alias;
                      }
                    }
                    let temp = this.round(result['Temp'] ,1);
                    //update temp and timestamp
                    let dummy = result['timestamp'].split(' ');
                    let dummy2 = dummy[0].split('-');
                    let date = dummy2[0]+'/'+dummy2[2]+'/'+dummy2[1];
                    let fullfixed = date+' '+dummy[1];
                    var d = new Date(fullfixed);
                    this.dashboard[s].telemetry = temp;
                    this.dashboard[s].humi = result['Humi'];
                    this.dashboard[s].lastSeen = result['timestamp'];
                    document.getElementById(this.dashboard[s].id+'state').title = 'Ultimo dato: '+result['timestamp'];
                    let lastSeen = new Date(this.dashboard[s].lastSeen);
                    let timeElapsed = (this.date.getTime() - lastSeen.getTime()) / (1000*60);
                    if(timeElapsed > 30)
                    {
                      document.getElementById(this.dashboard[s].id+'state').style.backgroundColor = 'red';
                    }
                    //actualiza la vista manualmente
                    this.cdr.detectChanges();
                  })
                }
                if (this.dashboard[s].widgetType == 'WaterSGauge'){ //sub for water
                  this.dashSubs[s].s = this.telemetryService.getTelemetry(this.dashboard[s].id).subscribe(result =>{
                    for(let dev in this.Devices)
                    {
                      if(this.Devices[dev].bd_id == this.dashboard[s].id)
                      {
                        let dummy = this.dashboard[s].label.split(' ')[0];
                        this.dashboard[s].label = dummy+' '+this.Devices[dev].alias;
                      }
                    }
                    let flow = this.round(result['Caudal'] ,1);
                    //update flow and timestamp
                    let dummy = result['timestamp'].split(' ');
                    let dummy2 = dummy[0].split('-');
                    let date = dummy2[0]+'/'+dummy2[2]+'/'+dummy2[1];
                    let fullfixed = date+' '+dummy[1];
                    var d = new Date(fullfixed);
                    this.dashboard[s].telemetry = flow;
                    this.dashboard[s].lastSeen = result['timestamp'];
                    document.getElementById(this.dashboard[s].id+'state').title = 'Ultimo dato: '+result['timestamp'];
                    let lastSeen = new Date(this.dashboard[s].lastSeen);
                    let timeElapsed = (this.date.getTime() - lastSeen.getTime()) / (1000*60);
                    if(timeElapsed > 30)
                    {
                      document.getElementById(this.dashboard[s].id+'state').style.backgroundColor = 'red';
                    }
                    //actualiza la vista manualmente
                    this.cdr.detectChanges();
                  })
                }
                if (this.dashboard[s].widgetType == 'UPS1'){ //sub for water
                  this.dashSubs[s].s = this.telemetryService.getTelemetry(this.dashboard[s].id).subscribe(result =>{
                    for(let dev in this.Devices)
                    {
                      if(this.Devices[dev].bd_id == this.dashboard[s].id)
                      {
                        let dummy = this.dashboard[s].label.split(' ')[0];
                        this.dashboard[s].label = dummy+' '+this.Devices[dev].alias;
                      }
                    }
                    //Porcentaje de carga
                    this.dashboard[s].telemetry.LoadP = result['LoadP'];
                    let loadVal = result['LoadP'];
                    //cambio el angulo de porcentaje de carga
                    let mappedValue = (loadVal - 0) * (150 - 30) / (100 - 0) + 30; //=> (value - x1) * (y2 - x2) / (y1 - x1) + x2;
                    document.getElementById(this.dashboard[s].id).style.transform = "rotate("+mappedValue+"deg)";
                    //cambio de color segun valor
                    document.getElementById(this.dashboard[s].id).style.background = this.getColor(loadVal); 
                    //Porcentaje de bateria
                    this.dashboard[s].telemetry.LoadBatt = result['LoadBatt'];
                    let loadBatt = result['LoadBatt'];
                    //para el angulo de porcentaje de bateria
                    let mappedValueBat = (loadBatt - 0) * (210 - 330) / (100 - 0) + 330;
                    document.getElementById(this.dashboard[s].id+"B").style.transform = "rotate("+mappedValueBat+"deg)";
                    //cambio de color segun valor
                    document.getElementById(this.dashboard[s].id+"B").style.background = this.getColor2(loadBatt); 
                    this.dashboard[s].telemetry.v1i = result['v1i'];
                    this.dashboard[s].telemetry.v1o = result['v1o'];
                    this.dashboard[s].telemetry.v2i = result['v2i'];
                    this.dashboard[s].telemetry.v2o = result['v2o'];
                    this.dashboard[s].telemetry.v3i = result['v3i'];
                    this.dashboard[s].telemetry.v3o = result['v3o'];
                    this.dashboard[s].telemetry.i1i = result['i1i'];
                    this.dashboard[s].telemetry.i1o = result['i1o'];
                    this.dashboard[s].telemetry.i2i = result['i2i'];
                    this.dashboard[s].telemetry.i2o = result['i2o'];
                    this.dashboard[s].telemetry.i3i = result['i3i'];
                    this.dashboard[s].telemetry.i3o = result['i3o'];
                    this.dashboard[s].telemetry.Tstat = result['Tstat'];
                    //update flow and timestamp
                    let dummy = result['timestamp'].split(' ');
                    let dummy2 = dummy[0].split('-');
                    let date = dummy2[0]+'/'+dummy2[2]+'/'+dummy2[1];
                    let fullfixed = date+' '+dummy[1];
                    var d = new Date(fullfixed);
                    this.dashboard[s].lastSeen = result['timestamp'];
                    //actualiza la vista manualmente
                    this.cdr.detectChanges();
                  })
                }

              }
            //retrieves the telemetry from "id"
            // var dummy = 'Sierra-Checa-Calle-MTCocina'.split("-");
            // this.dashboard[1].label = dummy[1]+"/"+dummy[2]+" "+dummy[3];
            // this.MTSub = this.telemetryService.getTelemetry('Sierra-Checa-Calle-MTCocina').subscribe(result =>{
            //   let temp = this.round(result['Temp'] ,1);
            //   //update current
            //   let dummy = result['timestamp'].split(' ');
            //   let dummy2 = dummy[0].split('-');
            //   let date = dummy2[1]+'/'+dummy2[2]+'/'+dummy2[0];
            //   let fullfixed = date+' '+dummy[1];
            //   var d = new Date(fullfixed);
            //   this.dashboard[1].telemetry = temp;
            //   this.dashboard[1].lastSeen = d;
            // });

            // var dummy2 = 'Sierra-Checa-Calle-TTACOMAP'.split("-");;
            // this.dashboard[2].label = dummy2[1]+'/'+dummy2[2] + ' '+dummy2[3] 
            // this.PMSub = this.telemetryService.getTelemetry('Sierra-Checa-Calle-TTACOMAP').subscribe(result =>{
            //   //this.telemetrys = result;
            //   //update current
            //   let dummy = result['timestamp'].split(' ');
            //   let dummy2 = dummy[0].split('-');
            //   let date = dummy2[1]+'/'+dummy2[2]+'/'+dummy2[0];
            //   let fullfixed = date+' '+dummy[1];
            //   var d = new Date(fullfixed);
            //   this.dashboard[2].lastSeen = d;
            //   this.dashboard[2].telemetry.v1 = result['v1'];
            //   this.dashboard[2].telemetry.v2 = result['v2'];
            //   this.dashboard[2].telemetry.v3 = result['v3'];
            //   this.dashboard[2].telemetry.i1 = result['c1'];
            //   this.dashboard[2].telemetry.i2 = result['c2'];
            //   this.dashboard[2].telemetry.i3 = result['c3'];
            //   this.dashboard[2].telemetry.s1 = result['s1'];
            //   this.dashboard[2].telemetry.s2 = result['s2'];
            //   this.dashboard[2].telemetry.s3 = result['s3'];
            //   this.dashboard[2].telemetry.freq = result['freq'];
            //   this.dashboard[2].telemetry.fp = result['fp'];

            // });

            // var dummy3 = 'Sierra-Checa-Calle-PMCASA'.split("-");;
            // this.dashboard[3].label = dummy3[1]+'/'+dummy3[2] + ' '+dummy3[3] 
            // this.PMSub2 = this.telemetryService.getTelemetry('Sierra-Checa-Calle-PMCASA').subscribe(result =>{
            //   //this.telemetrys = result;
            //   //update current
            //   let dummy = result['timestamp'].split(' ');
            //   let dummy2 = dummy[0].split('-');
            //   let date = dummy2[1]+'/'+dummy2[2]+'/'+dummy2[0];
            //   let fullfixed = date+' '+dummy[1];
            //   var d = new Date(fullfixed);
            //   this.dashboard[3].lastSeen = d;
            //   this.dashboard[3].telemetry.v1 = result['v1'];
            //   this.dashboard[3].telemetry.v2 = result['v2'];
            //   this.dashboard[3].telemetry.v3 = result['v3'];
            //   this.dashboard[3].telemetry.i1 = result['c1'];
            //   this.dashboard[3].telemetry.i2 = result['c2'];
            //   this.dashboard[3].telemetry.i3 = result['c3'];
            //   this.dashboard[3].telemetry.s1 = result['s1'];
            //   this.dashboard[3].telemetry.s2 = result['s2'];
            //   this.dashboard[3].telemetry.s3 = result['s3'];
            //   this.dashboard[3].telemetry.freq = result['freq'];
            //   this.dashboard[3].telemetry.fp = result['fp'];

            // });

            // var dummy4 = 'Sierra-Checa-Calle-TempMaster'.split("-");;
            // this.dashboard[4].label = dummy4[1]+'/'+dummy4[2] + ' '+dummy4[3];
            // this.dashboard[5].label = dummy4[1]+"/"+dummy4[2]+" "+dummy4[3];
            // let otherm = this.telemetryService.getTelemetry('Sierra-Checa-Calle-TempMaster').subscribe(result =>{
            //   let temp = this.round(result['Temp'] ,1);
            //   let elementT = document.getElementById('temperature');
            //   elementT.style.height = (temp - -20) / (50 - -20) * 100 + "%";
            //   elementT.dataset.value = temp + "°C";
            //   //update current
            //   let dummy = result['timestamp'].split(' ');
            //   let dummy2 = dummy[0].split('-');
            //   let date = dummy2[1]+'/'+dummy2[2]+'/'+dummy2[0];
            //   let fullfixed = date+' '+dummy[1];
            //   var d = new Date(fullfixed);
            //   this.dashboard[4].telemetry = temp;
            //   this.dashboard[6].telemetry = (temp - 0) / (100 - 0) * 100;
            //   this.dashboard[4].lastSeen = d;
            //   this.dashboard[5].lastSeen = d;
            // });
              
            })
          }
          else
          {
            this.Snames = ['Default'];
            this.TabIndex = this.Snames[0];
            this.InitialLoadingPromise = Promise.resolve(false);
            this.authService.createUserDash(this.userUid, this.dashboard, this.appComponent.selectedProyect['id']);
          }
        })      
      })
  
      this.myNewDims = window.innerHeight -45;
      this.myNewDims2 = window.innerHeight -88;
      //-----------------------------
      //------ Gets current user logged in and retrieve places-devices ------
      this.delay(50).then(any=>{
        this.getCurrentUser();
        
        //retrieves the devices
        this.marksSub = this.markersService.getMarkers().subscribe(marker =>{
          this.Devices = [];
          this.markers = marker;
          for(let site in marker)
          {
            for(let typedev in marker[site]["devices"])
            {
              for(let dev in marker[site]["devices"][typedev])
              {
                if(marker[site]["devices"][typedev][dev].type != 'IO')
                {
                  let body = marker[site]["devices"][typedev][dev];
                  body.zone = marker[site]["zone"];
                  body.city = marker[site]["city"];
                  body.office = marker[site]["office"];
                  this.Devices.push(body);
                }
              }
            }
          }
          this.devicesData = new MatTableDataSource(this.Devices);
          this.filteredDevices = this.SearchBarControl.valueChanges.pipe(
            startWith(''),
            map(value => this._filter(value))
          );
      })

        //observer to get view size 
        this.subObserver = this.observer.getMode().subscribe(result =>{
        this.isMobile = result.matches;
      })

        ///retrieves alarms to plot
        // this.subAlarms = this.alarmService.getAlarms().subscribe(res => {
        //   let timestamp = res.map(res => res['timestamp']);
        //   let value = res.map(res => res['value']);
          
        // })
    
    });
    
  }

  //funcion para filtrar los sites
  private _filter(value: string): Object[] {
    this.devicesData.filter = value.trim().toLowerCase();
    let result: object[] = [];
    for (let index = 0; index < this.devicesData.filteredData.length; index++) {
      result.push({'city': this.devicesData.filteredData[index]['city'], 'office': this.devicesData.filteredData[index]['office'], 'type': this.devicesData.filteredData[index]['type'], 'zone': this.devicesData.filteredData[index]['zone'], 'alias': this.devicesData.filteredData[index]['alias'], 'bd_id': this.devicesData.filteredData[index]['bd_id'] });
    }
    return result;
    // return [{"s": "a"}]
  }

  ngOnDestroy(){
    this.cdr.detach();
    clearInterval(this.interval);
    clearInterval(this.intervalTime);

    if (this.updateOnExit) {  //se guarda en BDD si es necesario
      this.authService.UpdateUserDashboardMonitoring(this.userUid, this.dashboard, this.Snames.indexOf(this.TabIndex), this.appComponent.selectedProyect['id']);
      this.updateOnExit = false;
      this.snack.open('Cambios Guardados con exito!', '', {duration: 1000})
    }
    
    try {
      for(let widget in this.dashSubs){
        if(widget != '0'){this.dashSubs[widget].s.unsubscribe();}
      }      
    } catch (error) {
      console.log(error)
    }

    
    this.dashboard = [];
    this.marksSub.unsubscribe();
    this.subObserver.unsubscribe();
    // this.subAlarms.unsubscribe();
    this.usrSub.unsubscribe();
    this.sizeChange = function() : void {};
    
    //console.log('desuscrito de todo!')
  }

  //Nuevas fn-----------------
  changeOptions(): void{
    if (this.options.api && this.options.api.optionsChanged){
      this.options.api.optionsChanged();
    }
  }

  removeItem($event: MouseEvent | TouchEvent, item): void {
    $event.preventDefault();
    $event.stopPropagation();
    //se elimina la coneccion con BDD para evitar errores y consumo de memoria.
    let index = this.dashboard.indexOf(item);
    if(this.dashSubs[index].s != undefined){
      this.dashSubs[index].s.unsubscribe();
    }

    this.dashboard.splice(this.dashboard.indexOf(item), 1);
    this.dashSubs.splice(this.dashboard.indexOf(item), 1);
    //this.explode($event.clientX - 100, $event.clientY);
    //se actualiza el dashboard en backend
    //se quitan los objetos en variable dashboard.
    // let dummyDash = [];
    //   this.dashboard.forEach(element => {
    //     if(element.sub != undefined)
    //       {
    //         element.sub = '';
    //       }
    //     dummyDash.push(element);
    //   });
    this.authService.UpdateUserDashboardMonitoring(this.userUid, this.dashboard, this.Snames.indexOf(this.TabIndex), this.appComponent.selectedProyect['id']);
    this.cdr.detectChanges();
  }

  addItem(): void {
    this.dashboard.push({x: 0, y: 0, cols: 1, rows: 1});
    this.cdr.detectChanges();
  }

  //Cambio en gridster    

  //-----------Abre ventana de confirmacion----------------
  openConfirmDialog(event, item): void {
    if(item == 'delete')
    {
      const dialogRef = this.dialog.open(DialogOverviewConfirm, {
        width: '250px',
        data: 'Borrar Espacio'
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result == "ok"){this.deleteSpace('delete')}
      });
    }
    else
    {
      const dialogRef = this.dialog.open(DialogOverviewConfirm, {
        width: '250px',
        data: item
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result == "ok"){this.removeItem(event, item)}
      });
    }
    
  }

  //------- abre ventana de grafico -----------------
  openDialog(item, devtype): void {
    if (devtype == 'PM'){
      let alias = item.label.split(' ');
      alias = alias.slice(1).join(' ');
      let dummy = item.id.split('-');
      if(dummy.length >= 4 ){
        let dummy2 = dummy;
        dummy[3] = dummy2.slice(3,dummy2.length).join('-');
      }
      const dialogRef = this.dialog.open(DialogOverviewExampleDialog, {
        data: {name: dummy[3], zone: dummy[0], city: dummy[1], office: dummy[2], devtype: devtype, alias: alias, devices: this.Devices}
      });
    }

    if (devtype == 'MT'){
      console.log('MT dialog open:',item);
      let alias = item.label.split(' ');
      alias = alias.slice(1).join(' ');
      let dummy = item.id.split('-');
      if(dummy.length >= 4 ){
        let dummy2 = dummy;
        dummy[3] = dummy2.slice(3,dummy2.length).join('-');
      }
      const dialogRef = this.dialog.open(DialogOverviewExampleDialog, {
        data: {name: dummy[3], zone: dummy[0], city: dummy[1], office: dummy[2], devtype: devtype, alias: alias, devices: this.Devices}
      });
    }

    if (devtype == 'Gas'){
      let alias = item.label.split(' ');
      alias = alias.slice(1).join(' ');
      let dummy = item.id.split('-');
      if(dummy.length >= 4 ){
        let dummy2 = dummy;
        dummy[3] = dummy2.slice(3,dummy2.length).join('-');
      }
      const dialogRef = this.dialog.open(DialogOverviewExampleDialog, {
        data: {name: dummy[3], zone: dummy[0], city: dummy[1], office: dummy[2], devtype: devtype, alias: alias, devices: this.Devices}
      });
    }

    if (devtype == 'Agua'){
      let alias = item.label.split(' ');
      alias = alias.slice(1).join(' ');
      let dummy = item.id.split('-');
      if(dummy.length >= 4 ){
        let dummy2 = dummy;
        dummy[3] = dummy2.slice(3,dummy2.length).join('-');
      }
      const dialogRef = this.dialog.open(DialogOverviewExampleDialog, {
        data: {name: dummy[3], zone: dummy[0], city: dummy[1], office: dummy[2], devtype: devtype, alias: alias, devices: this.Devices}
      });
    }

    if (devtype == 'Diesel'){
      let alias = item.label.split(' ');
      alias = alias.slice(1).join(' ');
      let dummy = item.id.split('-');
      if(dummy.length >= 4 ){
        let dummy2 = dummy;
        dummy[3] = dummy2.slice(3,dummy2.length).join('-');
      }
      const dialogRef = this.dialog.open(DialogOverviewExampleDialog, {
        data: {name: dummy[3], zone: dummy[0], city: dummy[1], office: dummy[2], devtype: devtype, alias: alias, devices: this.Devices}
      });
    }
    
      

    //   dialogRef.afterClosed().subscribe(result => {
    //     console.log('Window closed');
    //   });
    // }
    // if (devtype == 'MT'){
    //   const dialogRef = this.dialog.open(DialogOverviewExampleDialog, {
    //     //width: '900px',
    //     //height: '60vh',
    //     data: {name: this.selectedMTDevName, zone: this.selectedDevCity, model: this.selectedMTDevModel, city: this.selectedDevZone, office: this.selectedDevOffice,
    //     chartdata: chartdata, value1: value1, value2: value2, value3: value3, value4: value4, devType: devtype, alias: this.selectedMTDevAlias}
    //   });
      

    //   dialogRef.afterClosed().subscribe(result => {
    //     console.log('Window closed');
    //   });
    // }
    // if (devtype == 'IO'){
    //   const dialogRef = this.dialog.open(DialogOverviewExampleDialog, {
    //     //width: '900px',
    //     //height: '60vh',
    //     data: {name: this.selectedIODevName, zone: this.selectedDevCity, model: this.selectedIODevModel, city: this.selectedDevZone, office: this.selectedDevOffice,
    //     chartdata: chartdata, value1: value1, value2: value2, value3: value3, value4: value4, devType: devtype}
    //   });
      

    //   dialogRef.afterClosed().subscribe(result => {
    //     console.log('Window closed');
    //   });
    // }
    // if (devtype == 'UPS'){
    //   const dialogRef = this.dialog.open(DialogOverviewExampleDialog, {
    //     //width: '900px',
    //     //height: '60vh',
    //     data: {name: this.selectedUPSDevName, zone: this.selectedDevCity, model: this.selectedUPSDevModel, city: this.selectedDevZone, office: this.selectedDevOffice,
    //     chartdata: chartdata, value1: value1, value2: value2, value3: value3, value4: value4, devType: devtype, alias: this.selectedUPSDevAlias}
    //   });
      

    //   dialogRef.afterClosed().subscribe(result => {
    //     console.log('Window closed');
    //   });
    
  }

  //------- abre ventana de configuracion de alarmas -----------------
  openAlarmsSetupDialog(item): void{
    if (item.widgetType == 'Energy3P'){
      let alias = item.label.split(' ');
      alias = alias.slice(1).join(' ');
      let dummy = item.id.split('-');
      if(dummy.length >= 4 ){
        let dummy2 = dummy;
        dummy[3] = dummy2.slice(3,dummy2.length).join('-');
      }
      const dialogRef = this.dialog.open(ViewEditAlarmsDialog, {
        data: {name: dummy[3], zone: dummy[0], city: dummy[1], office: dummy[2], devtype: "PM", alias: alias, devices: this.Devices}
      });
    }

    if (item.widgetType == 'TempOnly' || item.widgetType == 'TempOnlyGraph' || item.widgetType == 'TempOnlySGauge'){
      let alias = item.label.split(' ');
      alias = alias.slice(1).join(' ');
      let dummy = item.id.split('-');
      if(dummy.length >= 4 ){
        let dummy2 = dummy;
        dummy[3] = dummy2.slice(3,dummy2.length).join('-');
      }
      const dialogRef = this.dialog.open(ViewEditAlarmsDialog, {
        data: {name: dummy[3], zone: dummy[0], city: dummy[1], office: dummy[2], devtype: "MT", alias: alias, devices: this.Devices}
      });
    }

    if (item.widgetType == 'Gas'){
      let alias = item.label.split(' ');
      alias = alias.slice(1).join(' ');
      let dummy = item.id.split('-');
      if(dummy.length >= 4 ){
        let dummy2 = dummy;
        dummy[3] = dummy2.slice(3,dummy2.length).join('-');
      }
      const dialogRef = this.dialog.open(ViewEditAlarmsDialog, {
        data: {name: dummy[3], zone: dummy[0], city: dummy[1], office: dummy[2], devtype: "Gas", alias: alias, devices: this.Devices}
      });
    }

    if (item.widgetType == 'Agua'){
      let alias = item.label.split(' ');
      alias = alias.slice(1).join(' ');
      let dummy = item.id.split('-');
      if(dummy.length >= 4 ){
        let dummy2 = dummy;
        dummy[3] = dummy2.slice(3,dummy2.length).join('-');
      }
      const dialogRef = this.dialog.open(ViewEditAlarmsDialog, {
        data: {name: dummy[3], zone: dummy[0], city: dummy[1], office: dummy[2], devtype: "Agua", alias: alias, devices: this.Devices}
      });
    }

    if (item.widgetType == 'Diesel'){
      let alias = item.label.split(' ');
      alias = alias.slice(1).join(' ');
      let dummy = item.id.split('-');
      if(dummy.length >= 4 ){
        let dummy2 = dummy;
        dummy[3] = dummy2.slice(3,dummy2.length).join('-');
      }
      const dialogRef = this.dialog.open(ViewEditAlarmsDialog, {
        data: {name: dummy[3], zone: dummy[0], city: dummy[1], office: dummy[2], devtype: "Diesel", alias: alias, devices: this.Devices}
      });
    }

  }

  //------- abre ventana de nuevo espacio ------------
  openNewSpaceDialog(context): void {
    if(context == 'new')
    {
      const dialogRef = this.dialog.open(CreateEditSpace, {
        width: '250px',
        data: {id: null, context: 'new'}
      });
  
      dialogRef.afterClosed().subscribe(result => {
        if(result == 'ok'){console.log('no se crea nada')}
        else
        {
          if(this.Snames.length <  this.SpaceLimit)
          {this.createSpace(result.data);}
          else
          {this.snack.open('Limite superado, contacta con soporte para incrementar limite de espacios', '', { duration: 3000 })}
          
        }
      });
    }
    if(context == 'edit'){
      const dialogRef = this.dialog.open(CreateEditSpace, {
        width: '250px',
        data: {id: this.TabIndex, context: 'edit'}
      });
  
      dialogRef.afterClosed().subscribe(result => {
        if(result == 'ok'){console.log('no cambia nada')}
        else
        {
          console.log(result.data);
          this.updateSpaceName(result.data);
        }
      });
    }

  } 
  
  getCurrentUser(){
    this.usrSub = this.authService.isAuth().subscribe( user => {
    if (user){
      //console.log('User logged as: ', user.displayName);
      this.user.isLogged = true;
      this.user.photoUrl = user.photoURL;
      this.userUid = user.uid;
      
    } else {
      //console.log('not logged');
      this.user.isLogged = false;
    }
  })
  }

  //--------- Para agregar widget de MT -------
  addMTWidget(Gtype, id, alias){
    //Simple solo numeros
    if(Gtype == 'simple')
    {
      var dummy = id.split("-");;
      let label = dummy[1]+'/'+dummy[2] + ' '+alias;  
      let s = this.dashboard.length;
      this.dashboard.push({cols: 1, rows: 1, y: 1, x: 0, dragEnabled: true, widgetType: 'TempOnly', resizeEnabled: false, label: label, telemetry: '', lastSeen: '', humi: null, id: id});
      this.dashSubs.push({s: ''});
      //-----Aqui va el sub de datos para rellenar temp simple
      this.dashboard[s].telemetry = 22.1;
      this.dashboard[s].lastSeen = null
      //desactivado por dispositivos inventados
      this.dashSubs[s].s = this.telemetryService.getTelemetry(this.dashboard[s].id).subscribe(result =>{
        let temp = this.round(result['Temp'] ,1);
        //update temp and timestamp
        let dummy = result['timestamp'].split(' ');
        let dummy2 = dummy[0].split('-');
        let date = dummy2[1]+'/'+dummy2[2]+'/'+dummy2[0];
        let fullfixed = date+' '+dummy[1];
        var d = new Date(fullfixed);
        this.dashboard[s].telemetry = temp;
        this.dashboard[s].humi = result['Humi'];
        this.dashboard[s].lastSeen = fullfixed;
        //actualiza la vista manualmente
        this.cdr.detectChanges();
      })
      

    }
    //Con termometro
    if(Gtype == 'thermometer')
    {
      var dummy = id.split("-");;
      let label = dummy[1]+'/'+dummy[2] + ' '+alias;  
      let s = this.dashboard.length;
      this.dashboard.push({cols: 1, rows: 2, y: 0, x: 0, dragEnabled: true, widgetType: 'TempOnlyGraph', resizeEnabled: false, label: label, telemetry: '', lastSeen: '', humi: null, id: id});
      this.dashSubs.push({s: ''});
      //style on the go because why not
      let elementTStyle = document.head.appendChild(document.createElement("style"));
      elementTStyle.innerHTML = "#"+this.dashboard[s].id+" {bottom: 0;background: linear-gradient(#f17a65, #3dcadf) no-repeat bottom;width: 102%;border-radius: 20px;background-size: 100%;transition: all 0.2s ease-in-out;position: absolute;}";
      let elementTStyleTooltip = document.head.appendChild(document.createElement("style"));
      elementTStyleTooltip.innerHTML = "#"+this.dashboard[s].id+":before {content: attr(data-value);background: rgba(0, 0, 0, 0.7);color: mediumspringgreen;z-index: 2;padding: 5px 10px;border-radius: 5px;font-size: medium;line-height: 1;position: absolute;transform: translateY(50%);left: calc(100% + 1em / 1.5);top: calc(-1em + 5px - 5px * 2);}"
      let elementTStyleDash = document.head.appendChild(document.createElement("style"));
      elementTStyleDash.innerHTML = "#"+this.dashboard[s].id+":after {content: '';position: absolute;border-top: 0.4545454545em solid transparent;border-bottom: 0.4545454545em solid transparent;border-right: 0.6666666667em solid rgba(0, 0, 0, 0.7);left: 100%;top: calc(-1em / 2.2 + 5px);}"
      //end of style on the go
      this.dashSubs[s].s = this.telemetryService.getTelemetry(this.dashboard[s].id).subscribe(result =>{
        let temp = this.round(result['Temp'] ,1);
        let elementT = document.getElementById(this.dashboard[s].id);
        
        elementT.style.height = (temp - -20) / (50 - -20) * 100 + "%";
        elementT.dataset.value = temp + "°C";
        //update
        //this.dashboard[s].telemetry = (temp - 0) / (100 - 0) * 100;
        this.dashboard[s].humi = result['Humi'];
        this.dashboard[s].lastSeen = result['timestamp'];
        //actualiza la vista manualmente
        this.cdr.detectChanges();
      })

    }
    //con gauge
    if(Gtype == 'gauge'){
      var dummy = id.split("-");;
      let label = dummy[1]+'/'+dummy[2] + ' '+alias;  
      let s = this.dashboard.length;
      this.dashboard.push({cols: 1, rows: 1, y: 0, x: 0, dragEnabled: true, widgetType: 'TempOnlySGauge', resizeEnabled: false, label: label, telemetry: '', lastSeen: '', humi: null, id: id});
      this.dashSubs.push({s: ''});
      //-----Aqui va el sub de datos para rellenar temp simple
      this.delay(10).then(any =>{
        // let elementT = document.getElementById(this.dashboard[s].id);
        // elementT.style.height = (21.2 - -20) / (50 - -20) * 100 + "%";
        // elementT.dataset.value = 21.2 + "°C";
        this.dashboard[s].lastSeen = null
      })
      this.dashSubs[s].s = this.telemetryService.getTelemetry(this.dashboard[s].id).subscribe(result =>{
        let temp = this.round(result['Temp'] ,1);
        //update temp and timestamp
        let dummy = result['timestamp'].split(' ');
        let dummy2 = dummy[0].split('-');
        let date = dummy2[0]+'/'+dummy2[2]+'/'+dummy2[1];
        let fullfixed = date+' '+dummy[1];
        var d = new Date(fullfixed);
        this.dashboard[s].telemetry = temp;
        this.dashboard[s].humi = result['Humi'];
        this.dashboard[s].lastSeen = result['timestamp'];
        //actualiza la vista manualmente
        this.cdr.detectChanges();
      })
    }
    //se actualiza el dashboard en backend
    this.authService.UpdateUserDashboardMonitoring(this.userUid, this.dashboard, this.Snames.indexOf(this.TabIndex), this.appComponent.selectedProyect['id']);
    //se cierra el menu
    this.sidenav.toggle();
    //actualiza la vista manualmente
    this.cdr.detectChanges();
  }

  //--------- Para agregar widget de PM -------
  addPMWidget(Gtype, id, alias){
    if(Gtype == 'simple')
    {
      var dummy = id.split("-");      
      let label = dummy[1]+'/'+dummy[2] + ' '+alias;  
      if(dummy[2] == "Inaquito")
      {
        label = dummy[1]+'/Iñaquito '+alias;
      }
      let s = this.dashboard.length;
      this.dashboard.push({cols: 2, rows: 1, y: 0, x: 3, dragEnabled: true, widgetType: 'Energy3P', resizeEnabled: false, label: label, telemetry: {v1: 123, v2: 123, v3: 123, 
                                                                                                                 i1: 30, i2: 12.3, i3: 20.1,
                                                                                                                 s1: 12, s2: 7.3, s3: 9.4,
                                                                                                                 freq: 60, fp: 0.9}           , lastSeen: null, id: id});
      this.dashSubs.push({s: ''});
                                                                                                                 //-----Aqui va el sub de datos para rellenar temp simple
      this.dashboard[s].lastSeen = null
      this.dashSubs[s].s = this.telemetryService.getTelemetry(this.dashboard[s].id).subscribe(result =>{
          let dummy = result['timestamp'].split(' ');
          let dummy2 = dummy[0].split('-');
          let date = dummy2[1]+'/'+dummy2[2]+'/'+dummy2[0];
          let fullfixed = date+' '+dummy[1];
          var d = new Date(fullfixed);
          this.dashboard[s].lastSeen = fullfixed;
          this.dashboard[s].telemetry.v1 = result['v1'];
          this.dashboard[s].telemetry.v2 = result['v2'];
          this.dashboard[s].telemetry.v3 = result['v3'];
          this.dashboard[s].telemetry.i1 = result['c1'];
          this.dashboard[s].telemetry.i2 = result['c2'];
          this.dashboard[s].telemetry.i3 = result['c3'];
          this.dashboard[s].telemetry.s1 = result['s1'];
          this.dashboard[s].telemetry.s2 = result['s2'];
          this.dashboard[s].telemetry.s3 = result['s3'];
          this.dashboard[s].telemetry.freq = result['freq'];
          this.dashboard[s].telemetry.fp = result['fp'];
          //actualiza la vista manualmente
          this.cdr.detectChanges();
        })
    }
    //se actualiza el dashboard en backend
    //se quitan los objetos en variable dashboard.
    // let dummyDash = this.dashboard;
    // let dummyDash2=[];
    //   dummyDash.forEach(element => {
    //     if(element.sub != undefined)
    //       {
    //         element.sub = '';
    //       }
    //     dummyDash2.push(element);
    //   });
    // console.log(this.dashboard);
    let Ddash = [];
    //se elimina la coneccion con BDD para evitar errores y consumo de memoria.
    for(let index of this.dashboard)
    {
      Ddash.push(index);
    }

    this.authService.UpdateUserDashboardMonitoring(this.userUid, Ddash, this.Snames.indexOf(this.TabIndex), this.appComponent.selectedProyect['id']);
    //se cierra el menu
    this.sidenav.toggle();
    //actualiza la vista manualmente
    this.cdr.detectChanges();
  }

  //-------- Para agregar widget de Agua -------
  addWaterWidget(Gtype, id, alias){
    //con gauge
    if(Gtype == 'gauge'){
      var dummy = id.split("-");;
      let label = dummy[1]+'/'+dummy[2] + ' '+alias;  
      let s = this.dashboard.length;
      this.dashboard.push({cols: 1, rows: 1, y: 0, x: 0, dragEnabled: true, widgetType: 'WaterSGauge', resizeEnabled: false, label: label, telemetry: '', lastSeen: '', id: id});
      this.dashboard[s].telemetry = 10.7;
      this.dashboard[s].lastSeen = null;
    }
    //se cierra el menu
    this.sidenav.toggle();
    //actualiza la vista manualmente
    this.cdr.detectChanges();
  }

  //-------- Para agregar widget de Diesel -------
  addDieselWidget(Gtype, id, alias){
    //con gauge
    if(Gtype == 'gauge'){
      var dummy = id.split("-");;
      let label = dummy[1]+'/'+dummy[2] + ' '+alias;  
      let s = this.dashboard.length;
      this.dashboard.push({cols: 1, rows: 1, y: 0, x: 0, dragEnabled: true, widgetType: 'DieselSGauge', resizeEnabled: false, label: label, telemetry: '', lastSeen: '', id: id});
      this.dashboard[s].telemetry = 93.5;
      this.dashboard[s].lastSeen = null;
    }
    //se cierra el menu
    this.sidenav.toggle();
    //actualiza la vista manualmente
    this.cdr.detectChanges();
  }

  //-------- Para agregar widget de Diesel -------
  addGasWidget(Gtype, id, alias){
    //con gauge
    if(Gtype == 'GasIcon'){
      var dummy = id.split("-");;
      let label = dummy[1]+'/'+dummy[2] + ' '+alias;  
      let s = this.dashboard.length;
      this.dashboard.push({cols: 1, rows: 1, y: 0, x: 0, dragEnabled: true, widgetType: 'GasIcon', resizeEnabled: false, label: label, telemetry: '', lastSeen: '', id: id});
      this.dashboard[s].telemetry = 93.5;
      this.dashboard[s].lastSeen = null;
    }
    //se cierra el menu
    this.sidenav.toggle();
    //actualiza la vista manualmente
    this.cdr.detectChanges();
  }

  getColor(value){
    //value from 0 to 1
    var hue=((120-value)).toString(10);
    return ["hsl(",hue,",100%,40%)"].join("");
  }

  getColor2(value){
    //value from 0 to 1
    var hue=((value+5)).toString(10);
    return ["hsl(",hue,",100%,40%)"].join("");
  }

  //-------- Para agregar widget de UPS -------
  
  addUPSWidget(Gtype, id, alias){
    if(Gtype == 'UPS2')
    {
      var dummy = id.split("-");;
      let label = dummy[1]+'/'+dummy[2] + ' '+alias;  
      let s = this.dashboard.length;
      this.dashboard.push({cols: 2, rows: 1, y: 0, x: 3, dragEnabled: true, widgetType: 'GEN1', resizeEnabled: true, label: label, telemetry: {v1i: 123, v2i: 123, v3i: 123, 
                                                                                                                 v1o: 123, v2o: 123, v3o: 123,
                                                                                                                 i1i: 30, i2i: 12.3, i3i: 20.1,
                                                                                                                 i1o: 30, i2o: 12.3, i3o: 20.1,
                                                                                                                 status: 'NORMAL', Tbatt:16.5, Tstat: 'NORMAL', LoadP: 12.5,
                                                                                                                 freqi: 60, freqo: 60 }           , lastSeen: null, id: id});
      this.dashSubs.push({s: ''});
                                                                                                                 //-----Aqui va el sub de datos para rellenar temp simple
      this.dashboard[s].lastSeen = null
      //cambio por conexion para datos UPS
      // this.dashSubs[s].s = this.telemetryService.getTelemetry(this.dashboard[s].id).subscribe(result =>{
      //     let dummy = result['timestamp'].split(' ');
      //     let dummy2 = dummy[0].split('-');
      //     let date = dummy2[1]+'/'+dummy2[2]+'/'+dummy2[0];
      //     let fullfixed = date+' '+dummy[1];
      //     var d = new Date(fullfixed);
      //     this.dashboard[s].lastSeen = fullfixed;
      //     this.dashboard[s].telemetry.v1 = result['v1'];
      //     this.dashboard[s].telemetry.v2 = result['v2'];
      //     this.dashboard[s].telemetry.v3 = result['v3'];
      //     this.dashboard[s].telemetry.i1 = result['c1'];
      //     this.dashboard[s].telemetry.i2 = result['c2'];
      //     this.dashboard[s].telemetry.i3 = result['c3'];
      //     this.dashboard[s].telemetry.s1 = result['s1'];
      //     this.dashboard[s].telemetry.s2 = result['s2'];
      //     this.dashboard[s].telemetry.s3 = result['s3'];
      //     this.dashboard[s].telemetry.freq = result['freq'];
      //     this.dashboard[s].telemetry.fp = result['fp'];
      //     //actualiza la vista manualmente
      //     this.cdr.detectChanges();
      //   })
    }
    //se actualiza el dashboard en backend
    console.log(this.dashboard, 'aqui se actualiza solo uno');
    //se quitan los objetos en variable dashboard.
    // let dummyDash = this.dashboard;
    // let dummyDash2=[];
    //   dummyDash.forEach(element => {
    //     if(element.sub != undefined)
    //       {
    //         element.sub = '';
    //       }
    //     dummyDash2.push(element);
    //   });
    // console.log(this.dashboard);
    let Ddash = [];
    //se elimina la coneccion con BDD para evitar errores y consumo de memoria.
    for(let index of this.dashboard)
    {
      Ddash.push(index);
    }

    this.authService.UpdateUserDashboardMonitoring(this.userUid, Ddash, this.Snames.indexOf(this.TabIndex), this.appComponent.selectedProyect['id']);
    //se cierra el menu
    this.sidenav.toggle();
    //actualiza la vista manualmente
    this.cdr.detectChanges();
  }

  createSpace(name)
  {
    console.log(name, this.Snames.indexOf(this.TabIndex));
    this.Snames.push(name);
    this.Spaces.push([{cols: 2, rows: 1, y: 0, x: 0, dragEnabled: true, widgetType: 'Clock', resizeEnabled: false, minItemCols: 2, label: 'Fecha/Hora Actual'}])
    let index = this.Snames.indexOf(name);
    this.authService.createUserDashSpace(this.userUid, index, this.Snames, this.appComponent.selectedProyect['id']);
    this.ChangeSpaceTab(name);
    //actualiza la vista manualmente
    this.cdr.detectChanges();
  }

  updateSpaceName(item){
    this.Snames[this.Snames.indexOf(this.TabIndex)] = item;
    this.authService.UpdateSpaceName(this.userUid, this.Snames, this.appComponent.selectedProyect['id']);
    this.TabIndex = item;
    this.snack.open('Actualizado nombre de espacio', '', {duration: 1000});
    //actualiza la vista manualmente
    this.cdr.detectChanges();
  }

  deleteSpace(item){
    let index = this.Snames.indexOf(this.TabIndex);
    this.Snames.splice(index, 1);
    this.Spaces.splice(index, 1);
    console.log(this.Spaces);
    let body = {};
    for(let dash in this.Spaces) //transform array to obj for firebase
    {
      body[dash] = this.Spaces[dash];
    }
    this.authService.deleteUserSpace(this.userUid, body, this.Snames, this.appComponent.selectedProyect['id']);

    this.updateOnExit = false
    this.ChangeSpaceTab(this.Snames[0]);
    //actualiza la vista manualmente
    this.cdr.detectChanges();
  }

  ChangeSpaceTab(id){
    if(id != this.TabIndex) //si no se cambia el indice no se hace nada.....
    {
      this.InitialLoadingPromise = Promise.resolve(true);
      

      if (this.updateOnExit) {  //se guarda en BDD si es necesario
        this.authService.UpdateUserDashboardMonitoring(this.userUid, this.dashboard, this.Snames.indexOf(this.TabIndex), this.appComponent.selectedProyect['id']);
        this.updateOnExit = false;
        this.snack.open('Cambios Guardados con exito!', '', {duration: 1000})
      }
      
      for(let widget in this.dashSubs){
        if(widget != '0'){this.dashSubs[widget].s.unsubscribe();}
      }
      console.log('desuscrito de todo!')

      let index = this.Snames.indexOf(id); //set the index to new dashboard
      this.TabIndex = id;
      this.dashSubs = []; //reinicio dashsubs para evitar errores.
      this.dashboard = this.Spaces[index];
      this.delay(5).then(any =>{
        for(let s in this.dashboard){
          this.dashSubs.push({s: ''}); //agrego los subs
          //aqui crear los subs
          if (this.dashboard[s].widgetType == 'Clock'){continue} //skip clock widget
          if (this.dashboard[s].widgetType == 'Energy3P'){ //sub for PM widget
            this.dashSubs[s].s = this.telemetryService.getTelemetry(this.dashboard[s].id).subscribe(result =>{
              for(let dev in this.Devices)
              {
                if(this.Devices[dev].bd_id == this.dashboard[s].id)
                {
                  let dummy = this.dashboard[s].label.split(' ')[0];
                  this.dashboard[s].label = dummy+' '+this.Devices[dev].alias;
                }
              }
              let dummy = result['timestamp'].split(' ');
              let dummy2 = dummy[0].split('-');
              let date = dummy2[1]+'/'+dummy2[2]+'/'+dummy2[0];
              let fullfixed = date+' '+dummy[1];
              var d = new Date(fullfixed);
              this.dashboard[s].lastSeen = result['timestamp'];
              this.dashboard[s].telemetry.v1 = result['v1'];
              this.dashboard[s].telemetry.v2 = result['v2'];
              this.dashboard[s].telemetry.v3 = result['v3'];
              this.dashboard[s].telemetry.i1 = result['c1'];
              this.dashboard[s].telemetry.i2 = result['c2'];
              this.dashboard[s].telemetry.i3 = result['c3'];
              this.dashboard[s].telemetry.s1 = result['s1'];
              this.dashboard[s].telemetry.s2 = result['s2'];
              this.dashboard[s].telemetry.s3 = result['s3'];
              this.dashboard[s].telemetry.freq = result['freq'];
              this.dashboard[s].telemetry.fp = result['fp'];
              document.getElementById(this.dashboard[s].id+'state').title = 'Ultimo dato: '+result['timestamp'];
              let lastSeen = new Date(this.dashboard[s].lastSeen);
              let timeElapsed = (this.date.getTime() - lastSeen.getTime()) / (1000*60);
              if(timeElapsed > 30)
              {
                document.getElementById(this.dashboard[s].id+'state').style.backgroundColor = 'red';
              }
            })
          }
          if (this.dashboard[s].widgetType == 'TempOnly'){ //sub for MT simple widget
            this.dashSubs[s].s = this.telemetryService.getTelemetry(this.dashboard[s].id).subscribe(result =>{
              for(let dev in this.Devices)
              {
                if(this.Devices[dev].bd_id == this.dashboard[s].id)
                {
                  let dummy = this.dashboard[s].label.split(' ')[0];
                  this.dashboard[s].label = dummy+' '+this.Devices[dev].alias;
                }
              }
              let temp = this.round(result['Temp'] ,1);
              //update temp and timestamp
              let dummy = result['timestamp'].split(' ');
              let dummy2 = dummy[0].split('-');
              let date = dummy2[1]+'/'+dummy2[2]+'/'+dummy2[0];
              let fullfixed = date+' '+dummy[1];
              var d = new Date(fullfixed);
              this.dashboard[s].telemetry = temp;
              this.dashboard[s].lastSeen = result['timestamp'];
              document.getElementById(this.dashboard[s].id+'state').title = 'Ultimo dato: '+result['timestamp'];
              let lastSeen = new Date(this.dashboard[s].lastSeen);
              let timeElapsed = (this.date.getTime() - lastSeen.getTime()) / (1000*60);
              if(timeElapsed > 30)
              {
                document.getElementById(this.dashboard[s].id+'state').style.backgroundColor = 'red';
              }
            })
          }
          if (this.dashboard[s].widgetType == 'TempOnlyGraph'){ //sub for MT with graph widget
            //style on the go because why not
            let elementTStyle = document.head.appendChild(document.createElement("style"));
            elementTStyle.innerHTML = "#"+this.dashboard[s].id+" {bottom: 0;background: linear-gradient(#f17a65, #3dcadf) no-repeat bottom;width: 102%;border-radius: 20px;background-size: 100%;transition: all 0.2s ease-in-out;position: absolute;}";
            let elementTStyleTooltip = document.head.appendChild(document.createElement("style"));
            elementTStyleTooltip.innerHTML = "#"+this.dashboard[s].id+":before {content: attr(data-value);background: rgba(0, 0, 0, 0.7);color: mediumspringgreen;z-index: 2;padding: 5px 10px;border-radius: 5px;font-size: medium;line-height: 1;position: absolute;transform: translateY(50%);left: calc(100% + 1em / 1.5);top: calc(-1em + 5px - 5px * 2);}"
            let elementTStyleDash = document.head.appendChild(document.createElement("style"));
            elementTStyleDash.innerHTML = "#"+this.dashboard[s].id+":after {content: '';position: absolute;border-top: 0.4545454545em solid transparent;border-bottom: 0.4545454545em solid transparent;border-right: 0.6666666667em solid rgba(0, 0, 0, 0.7);left: 100%;top: calc(-1em / 2.2 + 5px);}"
            //end of style on the go
            this.dashSubs[s].s = this.telemetryService.getTelemetry(this.dashboard[s].id).subscribe(result =>{
              for(let dev in this.Devices)
              {
                if(this.Devices[dev].bd_id == this.dashboard[s].id)
                {
                  let dummy = this.dashboard[s].label.split(' ')[0];
                  this.dashboard[s].label = dummy+' '+this.Devices[dev].alias;
                }
              }
              let temp = this.round(result['Temp'] ,1);
              let elementT = document.getElementById(this.dashboard[s].id);
              
              elementT.style.height = (temp - -20) / (50 - -20) * 100 + "%";
              elementT.dataset.value = temp + "°C";
              //update
              let dummy = result['timestamp'].split(' ');
              let dummy2 = dummy[0].split('-');
              let date = dummy2[1]+'/'+dummy2[2]+'/'+dummy2[0];
              let fullfixed = date+' '+dummy[1];
              var d = new Date(fullfixed);
              //this.dashboard[s].telemetry = (temp - 0) / (100 - 0) * 100;
              this.dashboard[s].lastSeen = result['timestamp'];
              document.getElementById(this.dashboard[s].id+'state').title = 'Ultimo dato: '+result['timestamp'];
              let lastSeen = new Date(this.dashboard[s].lastSeen);
              let timeElapsed = (this.date.getTime() - lastSeen.getTime()) / (1000*60);
              if(timeElapsed > 30)
              {
                document.getElementById(this.dashboard[s].id+'state').style.backgroundColor = 'red';
              }
            })
          }
          if (this.dashboard[s].widgetType == 'TempOnlySGauge'){ //sub for MT with gauge widget
            this.dashSubs[s].s = this.telemetryService.getTelemetry(this.dashboard[s].id).subscribe(result =>{
              for(let dev in this.Devices)
              {
                if(this.Devices[dev].bd_id == this.dashboard[s].id)
                {
                  let dummy = this.dashboard[s].label.split(' ')[0];
                  this.dashboard[s].label = dummy+' '+this.Devices[dev].alias;
                }
              }
              let temp = this.round(result['Temp'] ,1);
              //update temp and timestamp
              let dummy = result['timestamp'].split(' ');
              let dummy2 = dummy[0].split('-');
              let date = dummy2[1]+'/'+dummy2[2]+'/'+dummy2[0];
              let fullfixed = date+' '+dummy[1];
              var d = new Date(fullfixed);
              this.dashboard[s].telemetry = temp;
              this.dashboard[s].lastSeen = result['timestamp'];
              document.getElementById(this.dashboard[s].id+'state').title = 'Ultimo dato: '+result['timestamp'];
              let lastSeen = new Date(this.dashboard[s].lastSeen);
              let timeElapsed = (this.date.getTime() - lastSeen.getTime()) / (1000*60);
              if(timeElapsed > 30)
              {
                document.getElementById(this.dashboard[s].id+'state').style.backgroundColor = 'red';
              }
            })
          }
          if (this.dashboard[s].widgetType == 'WaterSGauge'){ //sub for water
            this.dashSubs[s].s = this.telemetryService.getTelemetry(this.dashboard[s].id).subscribe(result =>{
              for(let dev in this.Devices)
              {
                if(this.Devices[dev].bd_id == this.dashboard[s].id)
                {
                  let dummy = this.dashboard[s].label.split(' ')[0];
                  this.dashboard[s].label = dummy+' '+this.Devices[dev].alias;
                }
              }
              let flow = this.round(result['Caudal'] ,1);
              //update flow and timestamp
              let dummy = result['timestamp'].split(' ');
              let dummy2 = dummy[0].split('-');
              let date = dummy2[1]+'/'+dummy2[2]+'/'+dummy2[0];
              let fullfixed = date+' '+dummy[1];
              var d = new Date(fullfixed);
              this.dashboard[s].telemetry = flow;
              this.dashboard[s].lastSeen = result['timestamp'];
              document.getElementById(this.dashboard[s].id+'state').title = 'Ultimo dato: '+result['timestamp'];
              let lastSeen = new Date(this.dashboard[s].lastSeen);
              let timeElapsed = (this.date.getTime() - lastSeen.getTime()) / (1000*60);
              if(timeElapsed > 30)
              {
                document.getElementById(this.dashboard[s].id+'state').style.backgroundColor = 'red';
              }
            })
          }
        }
      });
      this.InitialLoadingPromise = Promise.resolve(false);
    }
    this.cdr.detectChanges();
  }

  onContextMenu($event: MouseEvent, name) {
    console.log($event);

    let x= $event.clientX;
    let y= $event.clientY;
    //this.close();
    const positionStrategy = this.overlay.position()
      .flexibleConnectedTo({ x, y })
      .withPositions([
        {
          originX: 'end',
          originY: 'bottom',
          overlayX: 'end',
          overlayY: 'top',
        }
      ]);

    this.overlayRef = this.overlay.create({
      positionStrategy,
      scrollStrategy: this.overlay.scrollStrategies.close()
    });

    this.overlayRef.attach(new TemplatePortal(this.contextMenu, this.viewContainerRef, {
      $implicit: name
    }));

    this.sub = fromEvent<MouseEvent>(document, 'click')
      .pipe(
        filter(event => {
          const clickTarget = event.target as HTMLElement;
          return !!this.overlayRef && !this.overlayRef.overlayElement.contains(clickTarget);
        }),
        take(1)
      ).subscribe(() => this.close())

    //actualiza la vista manualmente
    this.cdr.detectChanges();
  }

  close() {
    this.cdr.detectChanges();
    this.sub && this.sub.unsubscribe();
    if (this.overlayRef) {
      this.overlayRef.dispose();
      this.overlayRef = null;
    }
  }

  toggleSidenav(){
    this.sidenav.toggle();
    this.delay(50).then(any =>{
      //actualiza la vista manualmente
      this.cdr.detectChanges();
    })
   
  }

  updateView(){
    //actualiza la vista manualmente
    this.cdr.detectChanges();
  }
  
  //       let histSub = this.requestService.sendRequest(name, 'PM', this.selectedDevZone, this.selectedDevCity, this.selectedDevOffice).subscribe(result =>{
  //         var i;
  //         var ts;

  //         if(typeof result[0] !== "undefined")
  //         {
  //           for(i= 9; i>-1; i--)
  //           {
  //             if (typeof result[i] !== "undefined") //esta comparacion de undefined funciona.
  //             {
  //               let dummy = result[i][19].split(' ');
  //               let dummy2 = dummy[0].split('-');
  //               let date = dummy2[1]+'/'+dummy2[2]+'/'+dummy2[0];
  //               let fullfixed = date+' '+dummy[1];
  //               var d = new Date(fullfixed);
  //               /*
  //               console.log(d);
  //               ts = result[i][19].split(" ");
  //               ts = ts[1];
  //               ts = ts.split(":");
  //               var hour = ts[0];
  //               var mins = ts[1];
  //               var year = new Date().getFullYear();
  //               var month = new Date().getMonth();
  //               var day = new Date().getDate();
  //               */
  //               ts = d;
  //               //updates the current chart
  //               this.update_chart(this.currentChart, [result[i][3], result[i][4], result[i][5]], ts);
  //               //updates the voltaje chart
  //               this.update_chart(this.vphaseChart, [result[i][0], result[i][1], result[i][2]], ts);
  //               //update line voltage
  //               this.update_chart(this.vlineChart, [result[i][16], result[i][17], result[i][18]], ts);
  //               //update apparent power
  //               this.update_chart(this.appowerChart, [result[i][10], result[i][11], result[i][12], result[i][13]], ts);
  //               //update active power
  //               this.update_chart(this.powerChart, [result[i][6], result[i][7], result[i][8], result[i][9]], ts);
  //               //update freq
  //               this.update_chart(this.fChart, [result[i][15]], ts);
  //               //update fp
  //               this.update_chart(this.fpChart, [result[i][14]], ts);
  //             };
  //           };
  //         }
  //         else
  //         {
  //           this.reset_allPMCharts();
  //         }
  //         this.redrawfunction(this.currentChart);
  //         this.redrawfunction(this.vphaseChart);
  //         this.redrawfunction(this.vlineChart);
  //         this.redrawfunction(this.appowerChart);
  //         this.redrawfunction(this.powerChart);
  //         this.redrawfunction(this.fChart);
  //         this.redrawfunction(this.fpChart);
  //         this.showloadingPM = false;
  //         histSub.unsubscribe();
  //       })
  //       //esto coloca el nombre del dispositvo en la ventana emergente
  //       this.selectedDevName = name;
  //       this.selectedDevModel = model;
  //       this.selectedDevAlias = alias;
  //       this.appComponent.zone = this.selectedDevZone;
  //       this.appComponent.city = this.selectedDevCity;
  //       this.appComponent.office = this.selectedDevOffice;
  //     }
  //   })
  // }


  round(value, precision) {
    var multiplier = Math.pow(10, precision || 0);
    return Math.round(value * multiplier) / multiplier;
  }

  update_chart(chart, telem, ts?){
    var data = chart.dataTable;
    var header = chart.dataTable[0]; //copy of header
    var year = new Date().getFullYear();
    var month = new Date().getMonth();
    var day = new Date().getDate();
    var hour = new Date().getHours();
    var mins = new Date().getMinutes();
    var secs = new Date().getSeconds();
    var newts = new Date(year, month, day, hour, mins, secs);
    var payload = [];
    if(ts != null){var d = new Date(ts); payload.push(d);}else{payload.push(newts);}
    
    data = data.slice(0); // make copy
    data.splice(0, 1);
    ///agregar
    var i
    for(i=0; i<telem.length; i++){
      payload.push(parseFloat(telem[i]));
    }
    data.splice(data.length+1, 1, payload);
    //data.splice(0, 1);
    data.splice(0, 1, header); 
    chart.dataTable = data;
  }

  bitArrayToInt(array, count)
  {
      let ret = 0;
      let tmp;
      for (let i = 0; i < count; i++) {
          tmp = array[i];
          ret |= tmp << (count - i - 1);
      }
      return ret;
  }

  // sendCommand(space){
  //   if (space == 1){this.O1Value = !this.O1Value; console.log(this.O1Value);}
  //   if (space == 2){this.O2Value = !this.O2Value; console.log(this.O2Value);}
  //   if (space == 3){this.O3Value = !this.O3Value; console.log(this.O3Value);}
  //   if (space == 4){this.O4Value = !this.O4Value; console.log(this.O4Value);}
  //   let dummy = [this.O4Value, this.O3Value, this.O2Value, this.O1Value];
  //   let result = this.bitArrayToInt(dummy, 4);
  //   console.log(this.selectedReg);
  //   console.log(this.selectedIODevName);
  //   this.requestService.sendIoTCommand(this.selectedReg, this.selectedIODevName, result).subscribe(result =>{console.log(result);})
  // }

  //funcion de explosion
  explode(x, y) {
    var particles = 40,
      // explosion container and its reference to be able to delete it on animation end
      explosion = $('<div class="explosion"></div>');
  
    // put the explosion container into the body to be able to get it's size
    $('body').append(explosion);
  
    // position the container to be centered on click
    explosion.css('left', x - explosion.width() / 2);
    explosion.css('top', y - explosion.height() / 2);
  
    for (var i = 0; i < particles; i++) {
      // positioning x,y of the particle on the circle (little randomized radius)
      var x:any = (explosion.width() / 2) + rand(80, 150) * Math.cos(2 * Math.PI * i / rand(particles - 10, particles + 10)),
        y:any = (explosion.height() / 2) + rand(80, 150) * Math.sin(2 * Math.PI * i / rand(particles - 10, particles + 10)),
        color = rand(0, 255) + ', ' + rand(0, 255) + ', ' + rand(0, 255), // randomize the color rgb
          // particle element creation (could be anything other than div)
        elm = $('<div class="particle" style="' +
          'background-color: rgb(' + color + ') ;' +
          'top: ' + y + 'px; ' +
          'left: ' + x + 'px; z-index: 150;"></div>');
  
      if (i == 0) { // no need to add the listener on all generated elements
        // css3 animation end detection
        elm.one('webkitAnimationEnd oanimationend msAnimationEnd animationend', function(e) {
          explosion.remove(); // remove this explosion container when animation ended
        });
      }
      explosion.append(elm);
    }

    function rand(min, max){
      return Math.floor(Math.random() * (max + 1)) + min;
    }
  }

  //funcion de delay
  async delay(ms: number) {
    await new Promise<void>(resolve => setTimeout(()=>resolve(), ms)).then(()=>this.updateView());
  }

}

//------ Componente para mostrar graficos historicos.
@Component({
  selector: 'dialog-overview-example-dialog',
  templateUrl: 'dialog-overview-example-dialog.html',
  styleUrls: ['dialog-overview-example-dialog.css']
})
export class DialogOverviewExampleDialog {
  datatable: any;
  showloading: boolean = false;

  bufferDataTable;

  constructor(
    public dialogRef: MatDialogRef<DialogOverviewExampleDialog>,
    private requestService: BQRequestService,
    private snackBar: MatSnackBar,
    private router: Router,
    private formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {
      this.formGroup = this.formBuilder.group({
        date1: new FormControl,
        date2: new FormControl,
        telemSelected: new FormControl,
        typeSelected: new FormControl,
        deviceSelectedPM: new FormControl,
        deviceSelectedMT: new FormControl,
        deviceSelectedUPS: new FormControl,
        deviceSelectedGas: new FormControl,
        deviceSelectedDiesel: new FormControl,
        deviceSelectedAgua: new FormControl,
        deviceSelectedIO: new FormControl,
      })
    }

  onNoClick(): void {
    this.dialogRef.close('done');
  }

  //--------Globals declarations ------------------
  public showkwh: boolean;            //Muestra kWh calculados en pantalla
  calculatedkwh;                      //guarda el calculo de los kwh
  public candownload: boolean;        //puede o no descargar los datos en pantalla
  public zone: string;                //zona seleccionada
  public city: string;                //ciudad seleccionada
  public office: string;              //sitio seleccionado
  public device: string;              //dispositivo seleccionado
  public alias: string;               //para ver alias
  formGroup: FormGroup;               //Grupo de control por usar overview
  public PMselected: string;          //PM seleccionado
  public PMList: string[];            //Para guardar lista de PM disponibles
  public MTselected: string;          //MT seleccionado
  public UPSselected: string;         //UPS seleccionado
  public IOselected: string;          //I/O seleccionado
  public Aguaselected: string;        //Agua seleccionado
  public Gasselected: string;         //Gas seleccionado
  public Dieselselected: string;      //Diesel seleccionado
  public typeSelected: string;        //tipo de dispositivo seleccionado
  public progressMode: string;        //tipo de barra de carga muestra diferentes estados de la carga
  public showProgress: boolean;       //muestra o no barra de carga

  //////////////////////dispositivos
  public devTypes = ["Energia", "Temperatura", "Gas", "Diesel", "Agua", "I/O"];
  public PMDevs = [];
  public MTDevs = [];
  public IODevs = [];
  public GasDevs = [];
  public DieselDevs = [];
  public AguaDevs = [];

  public Desde;
  public Hasta;


  public sub;                         //objeto de subscripcion para consulta BD
  public result;                      //para guardar respuesta de BD
  public SMAEpsilon = 50;             //epsilon para el algoritmo de reduccion?
  public selectedCount = 0;
  emptyTable =[                       //Tabla vacia para iniciar la grafica
    ['ts', '-', '-', '-' ],
    [new Date('2020-01-01 10:15'),  0, 0, 0],
    [new Date('2020-01-01 10:16'),  0, 0, 0],
    [new Date('2020-01-01 10:17'), 0, 0, 0],
    [new Date('2020-01-01 10:18'), 0, 0, 0],
    [new Date('2020-01-01 10:19'), 0, 0, 0],
    [new Date('2020-01-01 10:20'),  0, 0, 0],
    [new Date('2020-01-01 10:21'),  0, 0, 0],
    [new Date('2020-01-01 10:22'),  0, 0, 0],
    [new Date('2020-01-01 10:23'),  0, 0, 0],
    [new Date('2020-01-01 10:24'),  0, 0, 0],
  ];
  emptyTable1 =[                       //Tabla vacia para iniciar la grafica
    ['ts', '-'],
    [new Date('2020-01-01 10:15'),  0 ],
    [new Date('2020-01-01 10:16'),  0 ],
    [new Date('2020-01-01 10:17'), 0 ],
    [new Date('2020-01-01 10:18'), 0 ],
    [new Date('2020-01-01 10:19'), 0 ],
    [new Date('2020-01-01 10:20'),  0 ],
    [new Date('2020-01-01 10:21'),  0 ],
    [new Date('2020-01-01 10:22'),  0 ],
    [new Date('2020-01-01 10:23'),  0 ],
    [new Date('2020-01-01 10:24'),  0 ],
  ];
  maxDate = new Date(); //today
  dummy = new Date(); //buffer date
  minDate = new Date(this.dummy.setFullYear(this.dummy.getFullYear() - 1)); //one year back
  PMtelem = ["V1", "V2", "V3", "V1_V2", "V2_V3", "V3_V1", "I1", "I2", "I3", "P1", "P2", "P3", "PT", "S1", "S2", "S3", "ST", "FP", "E", "freq", "E1RET", "E2RET","E3RET","ERET"]; //telemetrias por dispositivo
  UPStelem = ["V1i", "V1o", "V2i", "V2o", "V3i", "V3o", "I1i", "I1o", "I2i", "I2o", "I3i", "I3o", "freqi", "freqo", "pLoad"];
  MTtelem = ["Temp", "Humi"];
  Aguatelem = ["Vol", "Caudal"];
  IOtelem = ["Input", "Out", "Forzado"];
  selected = {startDate: moment, endDate: moment};
  momentMinDate: moment.Moment = moment();
  momentMaxDate: moment.Moment = moment().subtract(1, 'years');
  //------End of Global declarations --------------  
  public NewGChart: GoogleChartInterface = {
    chartType: 'LineChart',
    dataTable: [['ts', ' ', { role: 'annotation' }, ' ', { role: 'annotation' }, ' ', { role: 'annotation' }],
    ['',          0, 0, 0, 0, 0, 0]],

    options:{
      legend: {position: 'top'},
      chartArea: { left: 65, right: 10, top: 30, bottom: 50},
      animation: {duration: 900, easing: 'inAndOut'},
      explorer: {
        axis: 'horizontal',
        maxZoomIn: 0,
        maxZoomOut: 1,
        keepInBounds: true,
        actions: ['dragToZoom', 'rightClickToReset']
      },
      hAxis: {
        textStyle:{ fontSize: 12},
        format: 'dd/MM/yyyy HH:mm'
      },
      vAxis: {
        visible: 'true',
        position: 'in',
        viewWindow: {min:0},
        textStyle:{ fontSize: 12},
      }

    }
  };

  @ViewChild(DaterangepickerDirective, { static: false }) pickerDirective: DaterangepickerDirective;

  @HostListener('window:resize', ['$event'])
  sizeChange($event){
    let cComponent = this.NewGChart.component;
    let wrapper = cComponent.wrapper;
    cComponent.draw();
    // let dummyDash = [];
    // this.dashboard.forEach(element => {
    //   if(element.sub != undefined)
    //     {
    //       element.sub = '';
    //     }
    //   dummyDash.push(element);
    // });
    //this.authService.UpdateUserDashboardMonitoring(this.appComponent.userUid, dummyDash, "0");
  }

  ngOnInit() {  
    //se fijan fechas para solo dar buscar en caso de ser necesario
    this.formGroup.get('date2').setValue(new Date());
    let dummyDate = new Date();
    dummyDate.setDate(dummyDate.getDate() - 1);
    this.formGroup.get('date1').setValue(dummyDate); //ayer
    
    this.Desde = dummyDate;
    this.Hasta = new Date();
    //relleno listas de dispositivos por tipo
    for(let dev in this.data['devices']){
      //console.log(this.data['devices'][dev])
      //relleno para PM
      if(this.data['devices'][dev]['type'] == 'PM')
      {
        let alias = this.data['devices'][dev]['zone']+'/'+this.data['devices'][dev]['city']+'/'+this.data['devices'][dev]['office']+' '+this.data['devices'][dev]['alias'] 
        this.PMDevs.push({alias: alias, id: this.data['devices'][dev]['bd_id']})
      }
      //relleno para MT
      if(this.data['devices'][dev]['type'] == 'MT')
      {
        console.log('entra en MT')
        let alias = this.data['devices'][dev]['zone']+'/'+this.data['devices'][dev]['city']+'/'+this.data['devices'][dev]['office']+' '+this.data['devices'][dev]['alias'] 
        this.MTDevs.push({alias: alias, id: this.data['devices'][dev]['bd_id']})
        console.log(this.MTDevs)
      }
      //relleno para Diesel
      if(this.data['devices'][dev]['type'] == 'Diesel')
      {
        let alias = this.data['devices'][dev]['zone']+'/'+this.data['devices'][dev]['city']+'/'+this.data['devices'][dev]['office']+' '+this.data['devices'][dev]['alias'] 
        this.PMDevs.push({alias: alias, id: this.data['devices'][dev]['bd_id']})
      }
      //relleno para Gas
      if(this.data['devices'][dev]['type'] == 'Gas')
      {
        let alias = this.data['devices'][dev]['zone']+'/'+this.data['devices'][dev]['city']+'/'+this.data['devices'][dev]['office']+' '+this.data['devices'][dev]['alias'] 
        this.PMDevs.push({alias: alias, id: this.data['devices'][dev]['bd_id']})
      }
      //relleno para Agua
      if(this.data['devices'][dev]['type'] == 'FlujoAgua')
      {
        let alias = this.data['devices'][dev]['zone']+'/'+this.data['devices'][dev]['city']+'/'+this.data['devices'][dev]['office']+' '+this.data['devices'][dev]['alias'] 
        this.PMDevs.push({alias: alias, id: this.data['devices'][dev]['bd_id']})
      }
      //relleno para IO
      if(this.data['devices'][dev]['type'] == 'IO')
      {
        console.log('entra en I/O')
        let alias = this.data['devices'][dev]['zone']+'/'+this.data['devices'][dev]['city']+'/'+this.data['devices'][dev]['office']+' '+this.data['devices'][dev]['alias'] 
        this.IODevs.push({alias: alias, id: this.data['devices'][dev]['bd_id']})
        console.log(this.IODevs)
      }
    }

    //inicializo selectores 
    this.typeSelected = this.data["devtype"];
    console.log(this.typeSelected);
    if(this.typeSelected == 'PM')
    {
      this.formGroup.get('typeSelected').setValue('Energia')
      this.formGroup.get('deviceSelectedPM').setValue(this.data['zone']+'-'+this.data['city']+'-'+this.data['office']+'-'+this.data['name'])
    }
    if(this.typeSelected == 'MT')
    {
      this.formGroup.get('typeSelected').setValue('Temperatura')
      this.formGroup.get('deviceSelectedMT').setValue(this.data['zone']+'-'+this.data['city']+'-'+this.data['office']+'-'+this.data['name'])
    }
    if(this.typeSelected == 'Gas')
    {
      this.formGroup.get('typeSelected').setValue('Gas')
      this.formGroup.get('deviceSelectedGas').setValue(this.data["name"])
    }    
    if(this.typeSelected == 'Diesel')
    {
      this.formGroup.get('typeSelected').setValue('Diesel')
      this.formGroup.get('deviceSelectedDiesel').setValue(this.data["name"])
    }
    if(this.typeSelected == 'FlujoAgua')
    {
      this.formGroup.get('typeSelected').setValue('Agua')
      this.formGroup.get('deviceSelectedAgua').setValue(this.data["name"])
    }
    if(this.typeSelected == 'IO')
    {
      this.formGroup.get('typeSelected').setValue('I/O')
      this.formGroup.get('deviceSelectedIO').setValue(this.data['zone']+'-'+this.data['city']+'-'+this.data['office']+'-'+this.data['name'])
    }

    this.alias = this.data['alias'];
    if (this.typeSelected == "PM"){
      this.PMselected = this.data["name"]
      this.formGroup.get('telemSelected').setValue(["I1", "I2", "I3"]);
    }
    if (this.typeSelected == "MT"){
      this.MTselected = this.data["name"]
      this.formGroup.get('telemSelected').setValue(['Temp']);
    }
    if (this.typeSelected == "UPS"){
      this.UPSselected = this.data["name"]
      this.formGroup.get('telemSelected').setValue('');
    }
    if (this.typeSelected == "Agua"){
      this.Aguaselected = this.data["name"]
      this.formGroup.get('telemSelected').setValue(['Caudal']);
    }
    if (this.typeSelected == "Gas"){
      this.Gasselected = this.data["name"]
      this.formGroup.get('telemSelected').setValue('');
    }
    if (this.typeSelected == "Diesel"){
      this.Dieselselected = this.data["name"]
      this.formGroup.get('telemSelected').setValue('');
    }
    if (this.typeSelected == "IO"){
      this.IOselected = this.data["name"]
      this.formGroup.get('telemSelected').setValue(['Out']);
    }
    this.delay(700).then(any =>{
      let size = Math.round( window.innerHeight / (100/65)) ; //74
      this.NewGChart.options.height = size;
      
      //electricidad
      let ccComponent = this.NewGChart.component;
      let ccwrapper = ccComponent.wrapper;
        //redraw
      ccComponent.draw();
      //deshabilito botones hasta despues de carga
      
      this.get_device_telemetry('');
      //a partir de aqui se colocan los bordes en botones
      let button = document.getElementById('6h');
      (document.getElementById('6h') as HTMLButtonElement).disabled = true;
      button.style.border = '';
      let b1d = document.getElementById('1d');
      (document.getElementById('1d') as HTMLButtonElement).disabled = true;
      b1d.style.border = '2px solid mediumblue';
      b1d.style.transform= 'scale(1.2) translateY(-5px)';
      let b1s = document.getElementById('1s');
      (document.getElementById('1s') as HTMLButtonElement).disabled = true;
      b1s.style.border = '';
      let b1m = document.getElementById('1m');
      (document.getElementById('1m') as HTMLButtonElement).disabled = true;
      b1m.style.border = '';
      let custom = document.getElementById('custom');
      (document.getElementById('custom') as HTMLButtonElement).disabled = true;
      custom.style.border = '';            
    })    
  };

  //actualizada quita tendencias a todo
  //Funcion completa para traer datos, procesarlos y graficarlos 
  get_device_telemetry(id: string){
    
    if(this.typeSelected == 'PM'){id = this.formGroup.get('deviceSelectedPM').value;}
    if(this.typeSelected == 'MT'){id = this.formGroup.get('deviceSelectedMT').value;}
    if(this.typeSelected == 'UPS'){id = this.formGroup.get('deviceSelectedUPS').value;}
    if(this.typeSelected == 'Gas'){id = this.formGroup.get('deviceSelectedGas').value;}
    if(this.typeSelected == 'Diesel'){id = this.formGroup.get('deviceSelectedDiesel').value;}
    if(this.typeSelected == 'Agua'){id = this.formGroup.get('deviceSelectedAgua').value;}
    if(this.typeSelected == 'IO'){id = this.formGroup.get('deviceSelectedIO').value;}
    
    console.log(id)
    //id = this.data['zone'] + '-'+ this.data['city'] + '-' + this.data['office'] + '-' + this.data['name'];
    this.showkwh = false;
    this.candownload = false;
    if (this.formGroup.get('date1').value == null || this.formGroup.get('date2').value == null)
      { 
        this.snackBar.open('Debe seleccionar fecha de inicio y fin!', 'x', {duration: 3500, verticalPosition: 'top'}); 
      }
      else
      {
        if (this.formGroup.get('date1').value > this.formGroup.get('date2').value)
        {
          this.snackBar.open('Fecha de inicio no puede ser mayor a fecha de fin', 'x', {duration: 3500, verticalPosition: 'top'});
          this.formGroup.get('date1').setValue(null);
          this.formGroup.get('date2').setValue(null);
        }
        else
        {
          if (this.formGroup.get("telemSelected").value == '')
            {
              this.snackBar.open('Debe seleccionar al menos un parametro', 'x', {duration: 3500, verticalPosition: 'top'});
              this.formGroup.get("telemSelected").setErrors({'notUnique': true});
            }
            else if(this.formGroup.get("telemSelected").value.length > 1 && this.formGroup.get("telemSelected").value[0] == 'E')
            {
              this.snackBar.open('Para ver energia solo debe estar seleccionado ese parametro', 'x', {duration: 3500, verticalPosition: 'top'});
              this.formGroup.get("telemSelected").setErrors({'notUnique': true});
            }
            else if(this.formGroup.get("telemSelected").value.length > 1 && this.formGroup.get("telemSelected").value[this.formGroup.get("telemSelected").value.length-1] == 'E')
            {
              this.snackBar.open('Para ver energia solo debe estar seleccionado ese parametro', 'x', {duration: 3500, verticalPosition: 'top'});
              this.formGroup.get("telemSelected").setErrors({'notUnique': true});
            }
            else if(id == null && this.typeSelected == 'PM')
            {
              this.snackBar.open('Debe seleccionar un PM', 'x', {duration: 3500, verticalPosition: 'top'});
              //this.PMselected.setErrors({'notUnique': true});
            }
            else if(id == null && this.typeSelected == 'MT')
            {
              this.snackBar.open('Debe seleccionar un MT', 'x', {duration: 3500, verticalPosition: 'top'});
              //this.MTselected.setErrors({'notUnique': true});
            }
            else if(this.UPSselected == null && this.typeSelected == 'UPS')
            {
              this.snackBar.open('Debe seleccionar un UPS', 'x', {duration: 3500, verticalPosition: 'top'});
              //this.UPSselected.setErrors({'notUnique': true});
            }
            else
            {
            this.formGroup.get("telemSelected").setErrors(null);
            this.progressMode = "query";
            this.showProgress = true;
            var dummy = id.split("-");
            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            ////////////// Aqui es diferente de GentecCloud por error al crear dispositivos con nombre invalido /////////////////
            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            if (dummy.length > 4)
              {
                var device = dummy[3] + '-' + dummy[4]
                var zone =  dummy[0];
                var city = dummy[1];
                var office = dummy[2];
              }
              else
              {
                var device = dummy[3];
                var zone =  dummy[0];
                var city = dummy[1];
                var office = dummy[2];
              }
            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            ///////////////////////////////////// Aqui termina la diferencia con GentecCloud ////////////////////////////////////
            /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            

            console.log(device, zone, city, office);

            //this.superChart.options.colors = ["#FE1B07", "#FFF", "#27C5F8", "#FFFF00"]; // esto vuelve a hacer visibles las lineas ocultas

            var startDate =this.formGroup.get('date1').value.getFullYear() + '-' + ( '0' + (this.formGroup.get('date1').value.getMonth()+1)).slice(-2) + '-' + ('0' + this.formGroup.get('date1').value.getDate()).slice(-2) + ' ' + ('0'+this.formGroup.get('date1').value.getHours()).slice(-2) + ':'+ this.formGroup.get('date1').value.getMinutes()+":00";
            
            var endDate = this.formGroup.get('date2').value.getFullYear() + '-' + ( '0' + (this.formGroup.get('date2').value.getMonth()+1)).slice(-2) + '-' + ('0' + this.formGroup.get('date2').value.getDate()).slice(-2) + ' ' + ('0' + this.formGroup.get('date2').value.getHours()).slice(-2) + ':'+ this.formGroup.get('date2').value.getMinutes()+":00"; //' 23:59:00'
            

            //aqui se procesa que parametros se piden
            var selectedParams = '';
            var headerParams = [];
            var d
            var j
            if (this.formGroup.get("telemSelected").value[0] == 'Humi')
            {
              selectedParams = selectedParams + 'Humi';
            }
            else if (this.formGroup.get("telemSelected").value[0] == 'I1')
            {
              selectedParams = selectedParams + 'C1';
            }
            else if (this.formGroup.get("telemSelected").value[0] == 'I2')
            {
              selectedParams = selectedParams + 'C2';
            }
            else if (this.formGroup.get("telemSelected").value[0] == 'I3')
            {
              selectedParams = selectedParams + 'C3';
            }
            else if (this.formGroup.get("telemSelected").value[0] == 'I1i')
            {
              selectedParams = selectedParams + 'C1i';
            }
            else if (this.formGroup.get("telemSelected").value[0] == 'I2i')
            {
              selectedParams = selectedParams + 'C2i';
            }
            else if (this.formGroup.get("telemSelected").value[0] == 'I3i')
            {
              selectedParams = selectedParams + 'C3i';
            }
            else if (this.formGroup.get("telemSelected").value[0] == 'I1o')
            {
              selectedParams = selectedParams + 'C1o';
            }
            else if (this.formGroup.get("telemSelected").value[0] == 'I2o')
            {
              selectedParams = selectedParams + 'C2o';
            }
            else if (this.formGroup.get("telemSelected").value[0] == 'I3o')
            {
              selectedParams = selectedParams + 'C3o';
            }
            else if (this.formGroup.get("telemSelected").value[0] == 'Forzado')
            {
              selectedParams = selectedParams + 'manual';
            }
            else
            {
              selectedParams = selectedParams + this.formGroup.get("telemSelected").value[0];
            }
            
            for (d= 1; d < this.formGroup.get("telemSelected").value.length; d++ )
              {
                if (this.formGroup.get("telemSelected").value[d] == 'Humi')
                {
                  selectedParams = selectedParams + ',Humi';
                }
                else if (this.formGroup.get("telemSelected").value[d] == 'I1')
                {
                  selectedParams = selectedParams + ',C1';
                }
                else if (this.formGroup.get("telemSelected").value[d] == 'I2')
                {
                  selectedParams = selectedParams + ',C2';
                }
                else if (this.formGroup.get("telemSelected").value[d] == 'I3')
                {
                  selectedParams = selectedParams + ',C3';
                }
                else if (this.formGroup.get("telemSelected").value[d] == 'I1i')
                {
                  selectedParams = selectedParams + ',C1i';
                }
                else if (this.formGroup.get("telemSelected").value[d] == 'I2i')
                {
                  selectedParams = selectedParams + ',C2i';
                }
                else if (this.formGroup.get("telemSelected").value[d] == 'I3i')
                {
                  selectedParams = selectedParams + ',C3i';
                }
                else if (this.formGroup.get("telemSelected").value[d] == 'I1o')
                {
                  selectedParams = selectedParams + ',C1o';
                }
                else if (this.formGroup.get("telemSelected").value[d] == 'I2o')
                {
                  selectedParams = selectedParams + ',C2o';
                }
                else if (this.formGroup.get("telemSelected").value[d] == 'I3o')
                {
                  selectedParams = selectedParams + ',C3o';
                }
                else if (this.formGroup.get("telemSelected").value[d] == 'Forzado')
                {
                  selectedParams = selectedParams + ',manual';
                }
                else
                {
                  selectedParams = selectedParams + ','+this.formGroup.get("telemSelected").value[d];
                }
                  
              }
            //aqui se procesan los parametros pedidos para asignar a la grafica
            headerParams[0] = 'ts';
            for (d= 0; d < this.formGroup.get("telemSelected").value.length; d++ )
            {
              headerParams[d+1] = this.formGroup.get("telemSelected").value[d];
            }

            //se hace wipe al dataset para no tener errores en el grafico luego
            this.update_chart(this.NewGChart, [0, 0, 0]);

            this.NewGChart.dataTable = this.emptyTable;

            /////////cambio por diferencia en coordinador/////////////////////
            if(this.typeSelected == 'Agua'){this.typeSelected = 'FlujoAgua'}
            //////////////////////////////////////////////////////////////////
            (document.getElementById('6h') as HTMLButtonElement).disabled = true;
            (document.getElementById('1d') as HTMLButtonElement).disabled = true;
            (document.getElementById('1s') as HTMLButtonElement).disabled = true;
            (document.getElementById('1m') as HTMLButtonElement).disabled = true;
            (document.getElementById('custom') as HTMLButtonElement).disabled = true;
            console.log('Sending request to BQ...:',device);
            this.sub = this.requestService.sendLargeRequestGraph(device, this.typeSelected, zone , city, office, selectedParams, startDate, endDate ).subscribe(result =>{
              var i;
              var ts;
              var tolerance: number = 0.1;
              if (result[0] != undefined)
              {var arrData = Object.keys(result).length; console.log('Query Size: ', arrData); console.log(result);
              this.candownload = true;
              this.result = result;
              this.zone = zone;
              this.city = city;
              this.office = office;
              this.device = device;}

              if (arrData < 8000)
              {tolerance = 0;}
              else if (arrData > 8000  && arrData < 10000)
              {tolerance = 0.1;}
              else if (arrData > 10000 && arrData < 15000)
              {tolerance = 0.5;}
              else if (arrData > 15000 && arrData < 20000)
              {tolerance = 0.7;}
              else if (arrData > 20000 && arrData < 30000)
              {tolerance = 0.9;}
              else if (arrData > 30000 && arrData < 40000)
              {tolerance = 2;}
              else if (arrData > 40000 && arrData < 50000)
              {tolerance = 3;}
              else if (arrData > 50000 && arrData < 60000)
              {tolerance = 4;}
              else if (arrData > 60000 && arrData < 70000)
              {tolerance = 5.3;}
              else if (arrData > 70000 && arrData < 80000)
              {tolerance = 5.5;}
              else if (arrData > 80000 && arrData < 90000)
              {tolerance = 6.3;}
              else if (arrData > 90000 && arrData < 100000)
              {tolerance = 7;}
              else if (arrData > 100000 && arrData < 120000)
              {tolerance = 8;}
              else if (arrData > 120000)
              {tolerance = 8.7;}

              console.log(this.formGroup.get("telemSelected").value);
              //Heuristics para unidad en eje Y
              //Temp
              if (this.formGroup.get("telemSelected").value == 'Temp')
              {
                tolerance = 0.1;
                this.NewGChart.options.vAxis.viewWindow.min = 0;
                this.NewGChart.options.vAxis.title = '°C';
                this.NewGChart.options.trendlines = null;
                this.NewGChart.options.series = {0: {lineWidth: 1},
                                                  1: {lineWidth: 1}
                                                 };
              }
              //Humedad
              if (this.formGroup.get("telemSelected").value == 'Humi')
              {
                tolerance = 0.1;
                this.NewGChart.options.vAxis.viewWindow.min = 0;
                this.NewGChart.options.vAxis.title = '%';
                this.NewGChart.options.trendlines = null;
                this.NewGChart.options.series = {0: {lineWidth: 1},
                                                  1: {lineWidth: 1}
                                                 };
              }
              //Agua Flujo
              if (this.formGroup.get("telemSelected").value == 'Flujo')
              {
                tolerance = 0.1;
                this.NewGChart.options.vAxis.viewWindow.min = 0;
                this.NewGChart.options.vAxis.title = 'L/min';
                this.NewGChart.options.trendlines = null;
                this.NewGChart.options.series = {0: {lineWidth: 1},
                                                  1: {lineWidth: 1}
                                                 };
              }
              //IO no trend
              if (this.formGroup.get("telemSelected").value == 'Out')
              {
                tolerance = 0.1;
                this.NewGChart.options.vAxis.viewWindow.min = 0;
                this.NewGChart.options.vAxis.title = null;
                this.NewGChart.options.trendlines = null;
                this.NewGChart.options.series = {0: {lineWidth: 1},
                                                  1: {lineWidth: 1}
                                                 };
              }
              //IO no trend
              if (this.formGroup.get("telemSelected").value == 'Forzado')
              {
                tolerance = 0.1;
                this.NewGChart.options.vAxis.viewWindow.min = 0;
                this.NewGChart.options.vAxis.title = null;
                this.NewGChart.options.trendlines = null;
                this.NewGChart.options.series = {0: {lineWidth: 1},
                                                  1: {lineWidth: 1}
                                                 };
              }
              //IO no trend
              if (this.formGroup.get("telemSelected").value == 'Input')
              {
                tolerance = 0.1;
                this.NewGChart.options.vAxis.viewWindow.min = 0;
                this.NewGChart.options.vAxis.title = null;
                this.NewGChart.options.trendlines = null;
                this.NewGChart.options.series = {0: {lineWidth: 1},
                                                  1: {lineWidth: 1}
                                                 };
              }              
              //IO no trend
              if (this.compare(this.formGroup.get("telemSelected").value, ['Input', 'Out']))
              {
                tolerance = 0.1;
                this.NewGChart.options.vAxis.viewWindow.min = 0;
                this.NewGChart.options.vAxis.title = null;
                this.NewGChart.options.trendlines = null;
                this.NewGChart.options.series = {0: {lineWidth: 1},
                                                  1: {lineWidth: 1}
                                                 };
              }
              //IO no trend
              if (this.compare(this.formGroup.get("telemSelected").value, ['Out', 'Forzado']))
              {
                tolerance = 0.1;
                this.NewGChart.options.vAxis.viewWindow.min = 0;
                this.NewGChart.options.vAxis.title = null;
                this.NewGChart.options.trendlines = null;
                this.NewGChart.options.series = {0: {lineWidth: 1},
                                                  1: {lineWidth: 1}
                                                 };
              }              
              //IO no trend
              if (this.compare(this.formGroup.get("telemSelected").value, ['Input', 'Forzado']))
              {
                tolerance = 0.1;
                this.NewGChart.options.vAxis.viewWindow.min = 0;
                this.NewGChart.options.vAxis.title = null;
                this.NewGChart.options.trendlines = null;
                this.NewGChart.options.series = {0: {lineWidth: 1},
                                                  1: {lineWidth: 1}
                                                 };
              }
              //Agua Volumen
              if (this.formGroup.get("telemSelected").value == 'Vol')
              {
                tolerance = 0.1;
                this.NewGChart.options.vAxis.viewWindow.min = 0;
                this.NewGChart.options.vAxis.title = 'm3';
                this.NewGChart.options.trendlines = null;
                this.NewGChart.options.series = {0: {lineWidth: 1},
                                                  1: {lineWidth: 1},
                                                  3: {lineWidth: 1},
                                                 };
              }
              //freq
              if (this.formGroup.get("telemSelected").value == 'freq')
              {
                tolerance = 0.1;
                this.NewGChart.options.vAxis.viewWindow.min = 0;
                this.NewGChart.options.vAxis.title = 'Hz';
                this.NewGChart.options.trendlines = null;
                this.NewGChart.options.series = {0: {lineWidth: 1},
                                                  1: {lineWidth: 1}
                                                 };
              }
              //FP
              else if (this.formGroup.get("telemSelected").value == 'FP')
              {
                tolerance = 0.1;
                this.NewGChart.options.vAxis.viewWindow.min = null;
                this.NewGChart.options.vAxis.title = null;
                this.NewGChart.options.trendlines = null;
                this.NewGChart.options.series = {0: {lineWidth: 1},
                                                  1: {lineWidth: 1}
                                                 };
              }
              //E
              else if (this.formGroup.get("telemSelected").value == 'E')
              {
                this.NewGChart.options.vAxis.viewWindow.min = null;
                this.NewGChart.options.vAxis.title = 'kWh';
                this.NewGChart.options.trendlines = null;
                this.NewGChart.options.series = {0: {lineWidth: 1},
                                                  1: {lineWidth: 1}
                                                 };
                let dummy = parseFloat(this.result[0][0]) - parseFloat(this.result[arrData-1][0])
                this.calculatedkwh = dummy.toFixed(1);
                console.log(this.calculatedkwh);
                this.showkwh = true;                              
              }
              //Corrientes
              else if (this.formGroup.get("telemSelected").value == 'I1' || this.formGroup.get("telemSelected").value == 'I2' || this.formGroup.get("telemSelected").value == 'I3' || this.compare(this.formGroup.get("telemSelected").value, ['I1', 'I2']) || this.compare(this.formGroup.get("telemSelected").value, ['I1', 'I3']) || this.compare(this.formGroup.get("telemSelected").value, ['I2', 'I3']) || this.compare(this.formGroup.get("telemSelected").value, ['I1', 'I2', 'I3']))
              {
                this.NewGChart.options.vAxis.viewWindow.min = 0;
                this.NewGChart.options.vAxis.title = 'Amps';
                this.NewGChart.options.trendlines = null;
                this.NewGChart.options.series = {0: {lineWidth: 1},
                                                  1: {lineWidth: 1},
                                                  2: {lineWidth: 1}
                                                 };
              }
              //Potencia
              else if (this.formGroup.get("telemSelected").value == 'P1' || this.formGroup.get("telemSelected").value == 'P2' || this.formGroup.get("telemSelected").value == 'P3' || this.formGroup.get("telemSelected").value == 'PT' || this.compare(this.formGroup.get("telemSelected").value, ['P1', 'P2']) || this.compare(this.formGroup.get("telemSelected").value, ['P1', 'P3']) || this.compare(this.formGroup.get("telemSelected").value, ['P1', 'PT']) || this.compare(this.formGroup.get("telemSelected").value, ['P2', 'P3']) || this.compare(this.formGroup.get("telemSelected").value, ['P2', 'PT']) || this.compare(this.formGroup.get("telemSelected").value, ['P3', 'PT']) || this.compare(this.formGroup.get("telemSelected").value, ['P2', 'P3', 'PT']) || this.compare(this.formGroup.get("telemSelected").value, ['P1', 'P2', 'P3']) || this.compare(this.formGroup.get("telemSelected").value, ['P1', 'P2', 'P3', 'PT']))
              {
                this.NewGChart.options.vAxis.viewWindow.min = 0;
                this.NewGChart.options.vAxis.title = 'kW';
                this.NewGChart.options.trendlines = null;
                this.NewGChart.options.series = {0: {lineWidth: 1},
                                                  1: {lineWidth: 1},
                                                  2: {lineWidth: 1}
                                                 };
              }
              //Potencia
              else if (this.formGroup.get("telemSelected").value == 'S1' || this.formGroup.get("telemSelected").value == 'S2' || this.formGroup.get("telemSelected").value == 'S3' || this.formGroup.get("telemSelected").value == 'ST' || this.compare(this.formGroup.get("telemSelected").value, ['S1', 'S2']) || this.compare(this.formGroup.get("telemSelected").value, ['S1', 'S3']) || this.compare(this.formGroup.get("telemSelected").value, ['S1', 'ST']) || this.compare(this.formGroup.get("telemSelected").value, ['S2', 'S3']) || this.compare(this.formGroup.get("telemSelected").value, ['S2', 'ST']) || this.compare(this.formGroup.get("telemSelected").value, ['S3', 'ST']) || this.compare(this.formGroup.get("telemSelected").value, ['S2', 'S3', 'ST']) || this.compare(this.formGroup.get("telemSelected").value, ['S1', 'S2', 'S3']) || this.compare(this.formGroup.get("telemSelected").value, ['S1', 'S2', 'S3', 'ST']))
              {
                this.NewGChart.options.vAxis.viewWindow.min = 0;
                this.NewGChart.options.vAxis.title = 'kVA';
                this.NewGChart.options.trendlines = null;
                this.NewGChart.options.series = {0: {lineWidth: 1},
                                                  1: {lineWidth: 1},
                                                  2: {lineWidth: 1}
                                                 };
              }
              //Volts
              else if (this.formGroup.get("telemSelected").value == 'V1' || this.formGroup.get("telemSelected").value == 'V2' || this.formGroup.get("telemSelected").value == 'V3' || this.compare(this.formGroup.get("telemSelected").value, ['V1', 'V2']) || this.compare(this.formGroup.get("telemSelected").value, ['V1', 'V3']) || this.compare(this.formGroup.get("telemSelected").value, ['V2', 'V3']) || this.compare(this.formGroup.get("telemSelected").value, ['V1', 'V2', 'V3']))
              {
                this.NewGChart.options.vAxis.viewWindow.min = 0;
                this.NewGChart.options.vAxis.title = 'Volts';
                this.NewGChart.options.trendlines = null;
                this.NewGChart.options.series = {0: {lineWidth: 1},
                                                  1: {lineWidth: 1},
                                                  2: {lineWidth: 1}
                                                 };
              }
              //Volts
              else if (this.formGroup.get("telemSelected").value == 'V1_V2' || this.formGroup.get("telemSelected").value == 'V2_V3' || this.formGroup.get("telemSelected").value == 'V3_V1' || this.compare(this.formGroup.get("telemSelected").value, ['V1_V2', 'V2_V3']) || this.compare(this.formGroup.get("telemSelected").value, ['V1_V2', 'V3_V1']) || this.compare(this.formGroup.get("telemSelected").value, ['V2_V3', 'V3_V1']) || this.compare(this.formGroup.get("telemSelected").value, ['V1_V2', 'V2_V3', 'V3_V1']))
              {
                this.NewGChart.options.vAxis.viewWindow.min = 0;
                this.NewGChart.options.vAxis.title = 'Volts';
              }
              //Volts para UPS
              else if (this.formGroup.get("telemSelected").value == 'V1i' || this.formGroup.get("telemSelected").value == 'V1o' || this.formGroup.get("telemSelected").value == 'V2i' || this.formGroup.get("telemSelected").value == 'V2o' || this.formGroup.get("telemSelected").value == 'V3i' || this.formGroup.get("telemSelected").value == 'V3o' || this.compare(this.formGroup.get("telemSelected").value, ['V1i', 'V1o']) || this.compare(this.formGroup.get("telemSelected").value, ['V2i', 'V2o']) || this.compare(this.formGroup.get("telemSelected").value, ['V3i', 'V3o']) || this.compare(this.formGroup.get("telemSelected").value, ['V1i', 'V2i']) || this.compare(this.formGroup.get("telemSelected").value, ['V1i', 'V3i']) || this.compare(this.formGroup.get("telemSelected").value, ['V2i', 'V3i']) || this.compare(this.formGroup.get("telemSelected").value, ['V1o', 'V2o']) || this.compare(this.formGroup.get("telemSelected").value, ['V1o', 'V3i']) || this.compare(this.formGroup.get("telemSelected").value, ['V1i', 'V2i', 'V3i']) || this.compare(this.formGroup.get("telemSelected").value, ['V1o', 'V2o', 'V3o']) || this.compare(this.formGroup.get("telemSelected").value, ['V1i', 'V2i', 'V3i']) )
              {
                this.NewGChart.options.vAxis.viewWindow.min = 0;
                this.NewGChart.options.vAxis.title = 'Volts';
              }
              //Sino es ninguna unidad es null
              else
              {
                this.NewGChart.options.vAxis.viewWindow.min = 0;
                this.NewGChart.options.vAxis.title = null;
                this.NewGChart.options.trendlines = null;
                this.NewGChart.options.series = {0: {lineWidth: 1},
                                                  1: {lineWidth: 1},
                                                  2: {lineWidth: 1}
                                                 };
              }
              //Con esto se sabe de cuantos datos esta compuesto el resultado de BD
              if (result[0] != undefined)
              {var tsIndex = result[0].length;}
              else
              {tolerance = 0;}

              console.log('Epsilon: ',tolerance, tsIndex);
              if (tolerance != 0){
                if (tsIndex - 1 == 1) //si solo hay un valor seleccionado
                {  
                  let datas: ISimplifyArrayPoint[] =[[0,1]];
                  console.log(typeof result[0][0]);
                  if (typeof result[0][0] === 'string') //si es la energia se hace el parse a float
                  {
                    datas[0] =  [parseFloat(result[0][0]), 0]
                    for(i= 1 ; i<arrData; i++)     //Aqui se rellena una matriz con los datos de la matriz original (valor 1)
                    {
                      var det = [ result[i][0], i ];
                      datas.push(det[0]);
                      
                      datas[i] = [ parseFloat(result[i][0]), i ];
                    }
                  }
                  else if(typeof result[0][0] === 'boolean')//si es booleano lo pasa a 0 / 1
                  {
                    datas[0] =  [result[0][0]?1:0, 0]
                    for(i= 1 ; i<arrData; i++)     //Aqui se rellena una matriz con los datos de la matriz original (valor 1)
                    {
                      var det = [ result[i][0]?1:0, i ];
                      datas.push(det[0]);
                      
                      datas[i] = [ result[i][0]?1:0, i ];
                    }
                  }
                  else //sino se sige normal
                  {
                    datas[0] =  [result[0][0], 0]
                    for(i= 1 ; i<arrData; i++)     //Aqui se rellena una matriz con los datos de la matriz original (valor 1)
                    {
                      var det = [ result[i][0], i ];
                      datas.push(det[0]);
                      
                      datas[i] = [ result[i][0], i ];
                    }
                  }
                  var points: ISimplifyArrayPoint[] = datas;
                  var higQuality: boolean = false;
                  var simplifiedResult = SimplifyAP(points, tolerance, higQuality);
                  if (simplifiedResult.length < 100)
                    {
                      if(typeof result[0][0] != 'boolean')
                      {
                        simplifiedResult = SimplifyAP(points, 0, higQuality);//////////////////////////////////////////////////////
                      }
                      else
                      {
                        simplifiedResult = SimplifyAP(points, 0, higQuality);
                      }
                      
                      console.log('re-simplificado por pocos puntos')
                    }
                  //Aqui reviso cuales peticiones llevan promedio y tendencia
                  if (this.formGroup.get("telemSelected").value[0] != 'E' && this.formGroup.get("telemSelected").value[0] != 'freq' && this.formGroup.get("telemSelected").value[0] != 'FP' && this.formGroup.get("telemSelected").value[0] != 'Temp' && this.formGroup.get("telemSelected").value[0] != 'Vol' && this.formGroup.get("telemSelected").value[0] != 'Out' && this.formGroup.get("telemSelected").value[0] != 'Input' && this.formGroup.get("telemSelected").value[0] != 'Forzado')
                  {
                    headerParams[2] = this.formGroup.get("telemSelected").value[0]+"(Prom.)";
                    //aqui le doy otro grosor
                    this.NewGChart.options.series = {0: {lineWidth: 1},
                                                      1: {lineWidth: 2,
                                                          lineDashStyle: [2,2,2]}}
                    ///---------------Sin tendendcias en ningun lugar
                    // if(this.formGroup.get("telemSelected").value[0] != 'Caudal') //si es caudal no poner tendencia
                    // {  
                    //   this.NewGChart.options.trendlines = {
                    //     0: {
                    //       color: 'green',
                    //       lineWidth: 2,
                    //       type: 'lineal',
                    //       degree: 4,
                    //       opacity: 0.6,
                    //       tooltip: false,
                    //       visibleInLegend: true,
                    //       labelInLegend: 'Tendencia'
                    //     }
                    //   };
                    // }; 
                    var timeseries = require("timeseries-analysis");
                    
                    var SMA = [];
                    for(i = 0; i<simplifiedResult.length ; i++)
                    {
                      SMA.push([1]);
                      SMA[i] = [  result[simplifiedResult[i][1]][tsIndex -1] , simplifiedResult[i][0]];
                    }
                    console.log(SMA);
                    var t = new timeseries.main(SMA);
                    var final = t.ma( { period: 1 } ).smoother({ period: 300}).output();
                    console.log(final);

                    /*
                    var originalSize = Object.keys(result).length;
                    var SMA = [];
                    for(i=0; i<originalSize; i++)
                    {
                      SMA.push([1]);
                      SMA[i] = result[i][0];
                    }
                    SMA = ma(SMA, this.SMAEpsilon);

                    var SMA2 = [];
                    for(i = 0; i<simplifiedResult.length ; i++)
                    {
                      SMA2.push([1]);
                      SMA2[i] = SMA[simplifiedResult[i][1]];
                    }

                    SMA2 = ma(SMA2, this.SMAEpsilon);
                    console.log(SMA2);
                    */

                    var processedResult = [];
                    for(i = 0; i<simplifiedResult.length ; i++)
                    {
                      processedResult.push([1]);
                      //processedResult[i] = [ simplifiedResult[i][0], result[simplifiedResult[i][1]][tsIndex -1] ]
                      processedResult[i] = [ simplifiedResult[i][0], final[i][1], result[simplifiedResult[i][1]][tsIndex -1] ]
                    }
                    var devs = new timeseries.main(processedResult);
                    console.log('Desviacion: ' + devs.stdev());
                  }
                  else
                  {
                    if(this.formGroup.get("telemSelected").value[0] == 'Humi')
                    {
                      var timeseries = require("timeseries-analysis");
                      headerParams[2] = 'Min.';
                      headerParams[3] = 'Max.';
                      var stream = [];
                      for(i = 0; i<simplifiedResult.length ; i++)
                      {
                        stream[i] = 1;
                        stream[i] = [i, simplifiedResult[i][0]]
                      }
                      var s = new timeseries.main(stream);
                      var min = s.min().toFixed(1);
                      var max = s.max().toFixed(1);
                      var processedResult = [];
                      for(i = 0; i<simplifiedResult.length ; i++)
                      {
                        processedResult.push([1]);
                        processedResult[i] = [ simplifiedResult[i][0].toFixed(1), min, max, result[simplifiedResult[i][1]][tsIndex -1] ];
                      }
                    }
                    else if(this.formGroup.get("telemSelected").value[0] == 'Temp')
                    {
                      var timeseries = require("timeseries-analysis");
                      headerParams[2] = 'Min.';
                      headerParams[3] = 'Max.';
                      var stream = [];
                      for(i = 0; i<simplifiedResult.length ; i++)
                      {
                        stream[i] = 1;
                        stream[i] = [i, simplifiedResult[i][0]]
                      }
                      var s = new timeseries.main(stream);
                      var min = s.min().toFixed(1);
                      var max = s.max().toFixed(1);
                      var processedResult = [];
                      for(i = 0; i<simplifiedResult.length ; i++)
                      {
                        processedResult.push([1]);
                        processedResult[i] = [ simplifiedResult[i][0].toFixed(1), min, max, result[simplifiedResult[i][1]][tsIndex -1] ];
                      }
                    }
                    else
                    {
                      var processedResult = [];
                      for(i = 0; i<simplifiedResult.length ; i++)
                      {
                        processedResult.push([1]);
                        processedResult[i] = [ simplifiedResult[i][0], result[simplifiedResult[i][1]][tsIndex -1] ];
                      }
                    }
                  }

                }
                else if (tsIndex - 1 == 2) //Si hay seleccionados dos parametros hace matriz del segundo valor
                {
                  //Aqui se rellena una matriz con los datos de la matriz original (valor 1)
                  let datas: ISimplifyArrayPoint[] =[[0,1]];
                  if(typeof result[0][0] === 'boolean')
                  {
                    console.log('entra aqui')
                    datas[0] =  [result[0][0]?1:0, 0]
                    for(i= 1 ; i<arrData; i++)     
                    {
                      var det = [ result[i][0]?1:0, i ];
                      datas.push(det[0]);
                      datas[i] = [ result[i][0]?1:0, i ];
                    }
                  }
                  else
                  {
                    datas[0] =  [result[0][0], 0]
                    for(i= 1 ; i<arrData; i++)     
                    {
                      var det = [ result[i][0], i ];
                      datas.push(det[0]);
                      datas[i] = [ result[i][0], i ];
                    }
                  }
                  

                  //Aqui se rellena una matriz con los datos de la matriz original (valor 2)
                  let datas2: ISimplifyArrayPoint[] =[[0,1]];
                  if(typeof result[0][0] === 'boolean')
                  {
                    console.log('entra aqui')
                    datas2[0] =  [result[0][1]?1:0, 0]
                    for(i= 1 ; i<arrData; i++)     
                    {
                      var det = [ result[i][1]?1:0, i ];
                      datas2.push(det[0]);
                      datas2[i] = [ result[i][1]?1:0, i ];
                    }
                  }
                  else
                  {
                    datas2[0] =  [result[0][1], 0]
                    for(i= 1 ; i<arrData; i++)     
                    {
                      var det = [ result[i][1], i ];
                      datas2.push(det[0]);
                      datas2[i] = [ result[i][1], i ];
                    }
                  }
                  
                  var points: ISimplifyArrayPoint[] = datas;
                  var higQuality: boolean = false;
                  if(typeof result[0][0] != 'boolean')
                    {
                      var simpResult1 = SimplifyAP(points, tolerance, higQuality);
                    }
                    else
                    {
                      var simpResult1 = SimplifyAP(points, 0, higQuality);
                    }
                  

                  var points2: ISimplifyArrayPoint[] = datas2;
                  var higQuality: boolean = false;
                  if(typeof result[0][0] != 'boolean')
                    {
                      var simpResult2 = SimplifyAP(points2, tolerance, higQuality);//todo normal
                    }
                    else
                    {
                      var simpResult2 = SimplifyAP(points2, 0, higQuality);//sin simplificar
                    }
                  

                  if (simpResult1.length > simpResult2.length) //se ve cual grafico tuvo mas variacion y se utiliza como indice.
                    {
                      var simplifiedResult = simpResult1;
                      var processedResult = [];
                      if(typeof result[0][0] === 'boolean')
                        {
                         for(let s in result)
                         {
                           result[s][1] = result[s][1]?1:0; 
                         } 
                        }
                      for(i = 0; i<simplifiedResult.length ; i++)
                      {
                        processedResult.push([1]);
                        processedResult[i] = [ simplifiedResult[i][0], result[simplifiedResult[i][1]][1], result[simplifiedResult[i][1]][tsIndex -1] ]
                      }
                    }
                  else
                    {
                      var simplifiedResult = simpResult2;
                      var processedResult = [];
                      if(typeof result[0][0] === 'boolean')
                        {
                         for(let s in result)
                         {
                           result[s][0] = result[s][0]?1:0; 
                         } 
                        }
                      for(i = 0; i<simplifiedResult.length ; i++)
                      {
                        processedResult.push([1]);
                        processedResult[i] = [ result[simplifiedResult[i][1]][0], simplifiedResult[i][0], result[simplifiedResult[i][1]][tsIndex -1] ]
                      }
                    }
                }
                else if (tsIndex - 1 == 3) //Si hay seleccionados tres parametros hace matriz del tercer valor
                {
                  //Aqui se rellena una matriz con los datos de la matriz original (valor 1)
                  let datas: ISimplifyArrayPoint[] =[[0,1]];
                  datas[0] =  [result[0][0], 0]
                  for(i= 1 ; i<arrData; i++)     
                  {
                    var det = [ result[i][0], i ];
                    datas.push(det[0]);
                    datas[i] = [ result[i][0], i ];
                  }

                  //Aqui se rellena una matriz con los datos de la matriz original (valor 2)
                  let datas2: ISimplifyArrayPoint[] =[[0,1]];
                  datas2[0] =  [result[0][1], 0]
                  for(i= 1 ; i<arrData; i++)     
                  {
                    var det = [ result[i][1], i ];
                    datas2.push(det[0]);
                    datas2[i] = [ result[i][1], i ];
                  }

                  //Aqui se rellena una matriz con los datos de la matriz original (valor 3)
                  let datas3: ISimplifyArrayPoint[] =[[0,1]];
                  datas3[0] =  [result[0][2], 0]
                  for(i= 1 ; i<arrData; i++)     
                  {
                    var det = [ result[i][2], i ];
                    datas3.push(det[0]);
                    datas3[i] = [ result[i][2], i ];
                  }

                  var points: ISimplifyArrayPoint[] = datas;
                  var higQuality: boolean = false;
                  var simpResult1 = SimplifyAP(points, tolerance, higQuality);

                  var points2: ISimplifyArrayPoint[] = datas2;
                  var higQuality: boolean = false;
                  var simpResult2 = SimplifyAP(points2, tolerance, higQuality);

                  var points3: ISimplifyArrayPoint[] = datas3;
                  var higQuality: boolean = false;
                  var simpResult3 = SimplifyAP(points3, tolerance, higQuality);

                  if (simpResult1.length > simpResult2.length && simpResult3.length) //se ve cual grafico tuvo mas variacion y se utiliza como indice.
                    {
                      console.log('varia 1')
                      var simplifiedResult = simpResult1;
                      var processedResult = [];
                      for(i = 0; i<simplifiedResult.length ; i++)
                      {
                        processedResult.push([1]);
                        processedResult[i] = [ simplifiedResult[i][0], result[simplifiedResult[i][1]][1], result[simplifiedResult[i][1]][2], result[simplifiedResult[i][1]][tsIndex -1] ]
                      }
                    }
                  else if(simpResult2.length > simpResult1.length && simpResult3.length)
                    {
                      console.log('varia 2')
                      var simplifiedResult = simpResult2;
                      var processedResult = [];
                      for(i = 0; i<simplifiedResult.length ; i++)
                      {
                        processedResult.push([1]);
                        processedResult[i] = [ result[simplifiedResult[i][1]][0], simplifiedResult[i][0], result[simplifiedResult[i][1]][2], result[simplifiedResult[i][1]][tsIndex -1] ]
                      }
                    }
                  else if(simpResult3.length > simpResult1.length && simpResult2.length)
                    {
                      console.log('varia 3')
                      var simplifiedResult = simpResult3;
                      var processedResult = [];
                      for(i = 0; i<simplifiedResult.length ; i++)
                      {
                        processedResult.push([1]);
                        processedResult[i] = [ result[simplifiedResult[i][1]][0], result[simplifiedResult[i][1]][1], simplifiedResult[i][0], result[simplifiedResult[i][1]][tsIndex -1] ]
                      }
                    }
                  else
                  {
                    console.log('entra en caso extremo');
                    simpResult1 = SimplifyAP(points, 0, higQuality);

                    var simplifiedResult = simpResult1;
                      var processedResult = [];
                      for(i = 0; i<simplifiedResult.length ; i++)
                      {
                        processedResult.push([1]);
                        processedResult[i] = [ simplifiedResult[i][0], result[simplifiedResult[i][1]][1], result[simplifiedResult[i][1]][2], result[simplifiedResult[i][1]][tsIndex -1] ]
                      }
                  }

                }
                else if (tsIndex - 1 == 4) //Si hay seleccionados cuatro parametros hace matriz del cuarto valor
                {
                  //Aqui se rellena una matriz con los datos de la matriz original (valor 1)
                  let datas: ISimplifyArrayPoint[] =[[0,1]];
                  datas[0] =  [result[0][0], 0]
                  for(i= 1 ; i<arrData; i++)     
                  {
                    var det = [ result[i][0], i ];
                    datas.push(det[0]);
                    datas[i] = [ result[i][0], i ];
                  }

                  //Aqui se rellena una matriz con los datos de la matriz original (valor 2)
                  let datas2: ISimplifyArrayPoint[] =[[0,1]];
                  datas2[0] =  [result[0][1], 0]
                  for(i= 1 ; i<arrData; i++)     
                  {
                    var det = [ result[i][1], i ];
                    datas2.push(det[0]);
                    datas2[i] = [ result[i][1], i ];
                  }

                  //Aqui se rellena una matriz con los datos de la matriz original (valor 3)
                  let datas3: ISimplifyArrayPoint[] =[[0,1]];
                  datas3[0] =  [result[0][2], 0]
                  for(i= 1 ; i<arrData; i++)     
                  {
                    var det = [ result[i][2], i ];
                    datas3.push(det[0]);
                    datas3[i] = [ result[i][2], i ];
                  }

                  //Aqui se rellena una matriz con los datos de la matriz original (valor 4)
                  let datas4: ISimplifyArrayPoint[] =[[0,1]];
                  datas4[0] =  [result[0][3], 0]
                  for(i= 1 ; i<arrData; i++)     
                  {
                    var det = [ result[i][3], i ];
                    datas4.push(det[0]);
                    datas4[i] = [ result[i][3], i ];
                  }

                  var points: ISimplifyArrayPoint[] = datas;
                  var higQuality: boolean = false;
                  var simpResult1 = SimplifyAP(points, tolerance, higQuality);

                  var points2: ISimplifyArrayPoint[] = datas2;
                  var higQuality: boolean = false;
                  var simpResult2 = SimplifyAP(points2, tolerance, higQuality);

                  var points3: ISimplifyArrayPoint[] = datas3;
                  var higQuality: boolean = false;
                  var simpResult3 = SimplifyAP(points3, tolerance, higQuality);

                  var points4: ISimplifyArrayPoint[] = datas4;
                  var higQuality: boolean = false;
                  var simpResult4 = SimplifyAP(points4, tolerance, higQuality);

                  if (simpResult1.length > simpResult2.length && simpResult3.length && simpResult4.length) //se ve cual grafico tuvo mas variacion y se utiliza como indice.
                    {
                      var simplifiedResult = simpResult1;
                      var processedResult = [];
                      for(i = 0; i<simplifiedResult.length ; i++)
                      {
                        processedResult.push([1]);
                        processedResult[i] = [ simplifiedResult[i][0], result[simplifiedResult[i][1]][1], result[simplifiedResult[i][1]][2], result[simplifiedResult[i][1]][3], result[simplifiedResult[i][1]][tsIndex -1] ]
                      }
                    }
                  else if(simpResult2.length > simpResult1.length && simpResult3.length && simpResult4.length)
                    {
                      var simplifiedResult = simpResult2;
                      var processedResult = [];
                      for(i = 0; i<simplifiedResult.length ; i++)
                      {
                        processedResult.push([1]);
                        processedResult[i] = [ result[simplifiedResult[i][1]][0], simplifiedResult[i][0], result[simplifiedResult[i][1]][2], result[simplifiedResult[i][1]][3], result[simplifiedResult[i][1]][tsIndex -1] ]
                      }
                    }
                  else if(simpResult3.length > simpResult1.length && simpResult2.length && simpResult4.length)
                    {
                      var simplifiedResult = simpResult3;
                      var processedResult = [];
                      for(i = 0; i<simplifiedResult.length ; i++)
                      {
                        processedResult.push([1]);
                        processedResult[i] = [ result[simplifiedResult[i][1]][0], result[simplifiedResult[i][1]][1], simplifiedResult[i][0], result[simplifiedResult[i][1]][3], result[simplifiedResult[i][1]][tsIndex -1] ]
                      }
                    }
                  else if(simpResult4.length > simpResult1.length && simpResult2.length && simpResult3.length)
                    {
                      var simplifiedResult = simpResult3;
                      var processedResult = [];
                      for(i = 0; i<simplifiedResult.length ; i++)
                      {
                        processedResult.push([1]);
                        processedResult[i] = [ result[simplifiedResult[i][1]][0], result[simplifiedResult[i][1]][1], result[simplifiedResult[i][1]][2], simplifiedResult[i][0], result[simplifiedResult[i][1]][tsIndex -1] ]
                      }
                    }

                }
                          

                result = processedResult;
                arrData = Object.keys(result).length;
                console.log('Simplificado: ', arrData);
              }
              else if (tsIndex - 1 == 1 && this.formGroup.get("telemSelected").value[0] != 'E') //Si solo hay un valor y epsilon 0 se agrega la linea de promedio
              {
                if(tsIndex - 1 == 1 && this.formGroup.get("telemSelected").value[0] != 'freq' && this.formGroup.get("telemSelected").value[0] != 'Temp' && this.formGroup.get("telemSelected").value[0] != 'Caudal')
                {
                  headerParams[2] = this.formGroup.get("telemSelected").value[0]+"(Prom.)";
                  this.NewGChart.options.series = {0: {lineWidth: 1},
                                                      1: {lineWidth: 2}}
                  // this.NewGChart.options.trendlines = {
                  //   0: {
                  //     color: 'green',
                  //     lineWidth: 2,
                  //     type: 'polynomial',
                  //     degree: 4,
                  //     opacity: 0.6,
                  //     tooltip: false,
                  //     visibleInLegend: true,
                  //     labelInLegend: 'Tendencia'
                  //   }
                  // };
                  headerParams[2] = this.formGroup.get("telemSelected").value[0]+"(Prom.)";
                  this.NewGChart.options.series = {0: {lineWidth: 1},
                                                      1: {lineWidth: 2}}
                  var SMA = [];
                  for(i=0; i<Object.keys(result).length; i++)
                  {
                    SMA.push([1]);
                    SMA[i] = result[i][0];
                  }
                  SMA = ma(SMA, this.SMAEpsilon);

                  var processedResult = [];
                  for(i = 0; i<SMA.length ; i++)
                  {
                    processedResult.push([1]);
                    //processedResult[i] = [ simplifiedResult[i][0], result[simplifiedResult[i][1]][tsIndex -1] ]
                    processedResult[i] = [ result[i][0], SMA[i], result[i][tsIndex -1] ]
                  }
                  result = processedResult;
                  arrData = Object.keys(result).length;
                }
              }    
              
              if(this.formGroup.get("telemSelected").value[0] == 'Humi')
              {
                this.NewGChart.options.vAxis.title = '%';
              }
              if(this.formGroup.get("telemSelected").value[0] == 'Temp')
              {
                this.NewGChart.options.vAxis.title = '°C';
                //temp sin tendencia
                // this.NewGChart.options.trendlines = {
                //   0: {
                //     color: 'green',
                //     lineWidth: 2,
                //     type: 'lineal',
                //     degree: 4,
                //     opacity: 0.6,
                //     tooltip: false,
                //     visibleInLegend: true,
                //     labelInLegend: 'Tendencia'
                //   }
                // };
                this.NewGChart.options.series = {0: {lineWidth: 1},
                                                  1: {lineWidth: 2, lineDashStyle: [2,2,2], color: 'green'},
                                                  2: {lineWidth: 2, lineDashStyle: [2,2,2], color: 'orange'}
                                                 }
                                                 
              }
              if (tsIndex - 1 == 1) //si solo esta seleccionado uno se muestra unidad
              {
                if(this.formGroup.get("telemSelected").value[0] == 'Caudal')
                {
                  this.NewGChart.options.vAxis.title = 'L/min';
                  //temp sin tendencia
                  // this.NewGChart.options.trendlines = {
                  //   0: {
                  //     color: 'green',
                  //     lineWidth: 2,
                  //     type: 'lineal',
                  //     degree: 4,
                  //     opacity: 0.6,
                  //     tooltip: false,
                  //     visibleInLegend: true,
                  //     labelInLegend: 'Tendencia'
                  //   }
                  // };
                  this.NewGChart.options.series = {0: {lineWidth: 1},
                                                    1: {lineWidth: 2, lineDashStyle: [2,2,2], color: 'green'},
                                                    2: {lineWidth: 2, lineDashStyle: [2,2,2], color: 'orange'}
                                                  }
                                                  
                }
                if(this.formGroup.get("telemSelected").value[0] == 'Vol')
                {
                  this.NewGChart.options.vAxis.title = 'm3';
                  //temp sin tendencia
                  // this.NewGChart.options.trendlines = {
                  //   0: {
                  //     color: 'green',
                  //     lineWidth: 2,
                  //     type: 'lineal',
                  //     degree: 4,
                  //     opacity: 0.6,
                  //     tooltip: false,
                  //     visibleInLegend: true,
                  //     labelInLegend: 'Tendencia'
                  //   }
                  // };
                  this.NewGChart.options.series = {0: {lineWidth: 1},
                                                    1: {lineWidth: 2, lineDashStyle: [2,2,2], color: 'green'},
                                                    2: {lineWidth: 2, lineDashStyle: [2,2,2], color: 'orange'}
                                                  }
                                                  
                }
              }

              this.NewGChart.dataTable[0] = headerParams;

              var lastdatasize = this.NewGChart.dataTable.length;
              if (typeof result[0] !== "undefined")
                {var arrSize = result[0].length - 1;}

              //aqui se agranda la matriz para que concuerde con los datos que llegan de BD
              if (arrData > (lastdatasize - 1)){
                var toadd = arrData - ( lastdatasize - 1)
                for(i = 0; i<toadd; i++){
                  this.NewGChart.dataTable[i + lastdatasize] = this.NewGChart.dataTable[1];
                }
              }
              else if (arrData < (lastdatasize - 1)){ //Aqui se acorta la matriz por si vienen pocos valores de BD
                this.NewGChart.dataTable = []
                this.NewGChart.dataTable[0] = headerParams;
                var toadd = arrData;
                for(i = 0; i<toadd; i++){
                  this.NewGChart.dataTable[i + 1] = [new Date('2020-01-01 10:20'), 1];
                }       
              }

              console.log(result)
              if(typeof result[0] !== "undefined")
              {
                //var data = new google.visualization.DataTable();
                //data.addColumn('datetime', 'Time');
                //for (i= 1; i< headerParams.length; i++)
                //{
                //  data.addColumn('number', headerParams[i]);
                //}
                for(i= arrData - 1; i>-1; i--)
                {
                  if (typeof result[i] !== "undefined")
                  {
                    let dummy = result[i][arrSize].split(' ');
                    let dummy2 = dummy[0].split('-');
                    let date = dummy2[1]+'/'+dummy2[2]+'/'+dummy2[0];
                    let fullfixed = date+' '+dummy[1];
                    var d = new Date(fullfixed);
                    /*
                    ts = result[i][arrSize].split(" ");
                    ts = ts[1];
                    ts = ts.split(":");
                    var hour = ts[0];
                    var mins = ts[1];
                    var year = new Date().getFullYear();
                    var month = new Date().getMonth();
                    var day = new Date().getDate();
                    */
                    ts = d; //sets the date from payload
                    //updates the current chart for 4 values
                    if (result[i].length == 5)
                    {
                      this.update_chart(this.NewGChart, [result[i][0], result[i][1], result[i][2], result[i][3]], ts);
                    }
                    //updates the current chart for 3 values
                    if (result[i].length == 4)
                    {
                      this.update_chart(this.NewGChart, [result[i][0], result[i][1], result[i][2]], ts);
                    }
                    //updates the current chart for 2 values
                    if (result[i].length == 3)
                    {
                      //data.addRow([ts, result[i][0], result[i][1]])
                      this.update_chart(this.NewGChart, [result[i][0], result[i][1]], ts);
                    }
                    //updates the current chart for 1 values
                    if (result[i].length == 2)
                    {
                      //data.addRow([ts, result[i][0]])
                      this.update_chart(this.NewGChart, [result[i][0]], ts);
                    }
                  };
                };
              }
              else
              {
                let selectLength = this.formGroup.get("telemSelected").value.length;
                if(selectLength == 1)
                {
                  this.NewGChart.dataTable = this.emptyTable1;
                }
                else
                {
                  this.NewGChart.dataTable = this.emptyTable;
                }
                
                console.log(this.NewGChart);
                
                this.snackBar.open('No hay datos!.', 'x', {duration: 3500, verticalPosition: 'top'});
              }
              if(typeof result[0] !== "undefined")
              {
                //updates the current chart for 4 values
                if (result[0].length == 5)
                {
                  this.update_chart(this.NewGChart, [null, null, null, null], endDate);
                }
                //updates the current chart for 3 values
                if (result[0].length == 4)
                {
                  this.update_chart(this.NewGChart, [null, null, null], endDate);
                }
                //updates the current chart for 2 values
                if (result[0].length == 3)
                {
                  this.update_chart(this.NewGChart, [null, null], endDate);
                }
                //updates the current chart for 1 values
                if (result[0].length == 2)
                {
                  //data.addRow([ts, result[i][0]])
                  this.update_chart(this.NewGChart, [null], endDate);
                }
              }
              //var view = new google.visualization.DataView(data);
              //this.superChart.dataTable = view;
              /////////cambio por diferencia en coordinador/////////////////////
              if(this.typeSelected == 'FlujoAgua'){this.typeSelected = 'Agua'}
              //////////////////////////////////////////////////////////////////
              this.redrawfunction(this.NewGChart); 
              this.bufferDataTable = JSON.parse(JSON.stringify(this.NewGChart.dataTable));

              this.showProgress = false; 
              
              (document.getElementById('6h') as HTMLButtonElement).disabled = false;
              (document.getElementById('1d') as HTMLButtonElement).disabled = false;
              (document.getElementById('1s') as HTMLButtonElement).disabled = false;
              (document.getElementById('1m') as HTMLButtonElement).disabled = false;
              (document.getElementById('custom') as HTMLButtonElement).disabled = false;
              this.sub.unsubscribe();
            })
          }
      }
      }
  }

  onSelect(event) {    
    console.log(event);
    if(event['row'] == null)
    {
      console.log(event['column']);
      let index = parseInt(event['column']);
      let data = this.NewGChart.dataTable;
      for(let i = 0; i < data.length; i++)
      {
        data[i].splice(index, 1);
      }
      console.log(data, this.bufferDataTable);
      this.NewGChart.dataTable = data;
      let cComponent = this.NewGChart.component;
      let wrapper = cComponent.wrapper;
      cComponent.draw();
    }
    
  } 
  
  reloadChart()
  {
    let cComponent = this.NewGChart.component;
    let wrapper = cComponent.wrapper;
    let data = JSON.parse(JSON.stringify(this.bufferDataTable));

    for(let s in data)
    {
      if(parseInt(s) != 0)
      {
        let date = data[s][0].split('T');
        let time = date[1].split('.')[0];
        let d = [date[0], time].join(' ');
        data[s][0] = new Date(d);
      }
    }

    this.NewGChart.dataTable = data;
    cComponent.draw();
  }

  dateChange(desc){
    if(desc == '6H')
    {
      let start = new Date();
      let end = new Date();
      end.setHours(end.getHours() - 6);
      this.formGroup.get('date1').setValue(end);
      this.formGroup.get('date2').setValue(start);
      this.Desde = end;
      this.Hasta = start;
      console.log(this.formGroup.get('date1').value, this.formGroup.get('date2').value)
      this.get_device_telemetry('');
      //a partir de aqui se colocan los bordes en botones
      let button = document.getElementById('6h')
      button.style.border = '2px solid mediumblue'
      button.style.transform= 'scale(1.2) translateY(-5px)'
      let b1d = document.getElementById('1d')
      b1d.style.border = '';
      b1d.style.transform= 'scale(1) translateY(0px)';
      let b1s = document.getElementById('1s')
      b1s.style.border = '';
      b1s.style.transform= 'scale(1) translateY(0px)';
      let b1m = document.getElementById('1m')
      b1m.style.border = '';
      b1m.style.transform= 'scale(1) translateY(0px)';
      let bcustom = document.getElementById('custom')
      bcustom.style.border = 'transparent';
      bcustom.style.transform= 'scale(1) translateY(0px)';
    }

    if(desc == 'yesterday')
    {
      let start = new Date();
      let end = new Date();
      end.setDate(end.getDate() - 1);
      this.formGroup.get('date1').setValue(end);
      this.formGroup.get('date2').setValue(start);
      this.Desde = end;
      this.Hasta = start;
      console.log(this.formGroup.get('date1').value, this.formGroup.get('date2').value)
      this.get_device_telemetry('');
      //a partir de aqui se colocan los bordes en botones
      let button = document.getElementById('6h')
      button.style.border = ''      
      button.style.transform= 'scale(1) translateY(0px)';
      let b1d = document.getElementById('1d')
      b1d.style.border = '2px solid mediumblue';      
      b1d.style.transform= 'scale(1.2) translateY(-5px)';
      let b1s = document.getElementById('1s')
      b1s.style.border = '';
      b1s.style.transform= 'scale(1) translateY(0px)';
      let b1m = document.getElementById('1m')
      b1m.style.border = '';
      b1m.style.transform= 'scale(1) translateY(0px)';
      let bcustom = document.getElementById('custom')
      bcustom.style.border = 'transparent';
      bcustom.style.transform= 'scale(1) translateY(0px)';
    }
    
    if(desc == 'week')
    {
      let start = new Date();
      let end = new Date();
      end.setDate(end.getDate() - 7);
      this.formGroup.get('date1').setValue(end);
      this.formGroup.get('date2').setValue(start);
      this.Desde = end;
      this.Hasta = start;
      console.log(this.formGroup.get('date1').value, this.formGroup.get('date2').value)
      this.get_device_telemetry('');
      //a partir de aqui se colocan los bordes en botones
      let button = document.getElementById('6h')
      button.style.border = ''
      button.style.transform= 'scale(1) translateY(0px)';
      let b1d = document.getElementById('1d')
      b1d.style.border = '';
      b1d.style.transform= 'scale(1) translateY(0px)';
      let b1s = document.getElementById('1s')
      b1s.style.border = '2px solid mediumblue';
      b1s.style.transform= 'scale(1.2) translateY(-5px)'
      let b1m = document.getElementById('1m')
      b1m.style.border = '';
      b1m.style.transform= 'scale(1) translateY(0px)';
      let bcustom = document.getElementById('custom')
      bcustom.style.border = 'transparent';
      bcustom.style.transform= 'scale(1) translateY(0px)';
    }

    if(desc == 'month')
    {
      let start = new Date();
      let end = new Date();
      end.setMonth(end.getMonth() - 1);
      this.formGroup.get('date1').setValue(end);
      this.formGroup.get('date2').setValue(start);
      this.Desde = end;
      this.Hasta = start;
      console.log(this.formGroup.get('date1').value, this.formGroup.get('date2').value)
      this.get_device_telemetry(''); 
      //a partir de aqui se colocan los bordes en botones
      let button = document.getElementById('6h')
      button.style.border = ''
      button.style.transform= 'scale(1) translateY(0px)';
      let b1d = document.getElementById('1d')
      b1d.style.border = '';
      b1d.style.transform= 'scale(1) translateY(0px)';
      let b1s = document.getElementById('1s')
      b1s.style.border = '';
      b1s.style.transform= 'scale(1) translateY(0px)';
      let b1m = document.getElementById('1m')
      b1m.style.border = '2px solid mediumblue';
      b1m.style.transform= 'scale(1.2) translateY(-5px)'
      let bcustom = document.getElementById('custom')
      bcustom.style.border = 'transparent';
      bcustom.style.transform= 'scale(1) translateY(0px)';
    }

    if(desc == 'custom')
    {
      let startDate = this.selected.startDate['_d'];
      let endDate = this.selected.endDate['_d'];
      if(startDate != undefined)
      {
        this.formGroup.get('date1').setValue(startDate);
        this.formGroup.get('date2').setValue(endDate);
        this.Desde = startDate;
        this.Hasta = endDate;
        this.get_device_telemetry('');
        //a partir de aqui se colocan los bordes en botones
        let button = document.getElementById('6h')
        button.style.border = ''
        button.style.transform= 'scale(1) translateY(0px)';
        let b1d = document.getElementById('1d')
        b1d.style.border = '';
        b1d.style.transform= 'scale(1) translateY(0px)';
        let b1s = document.getElementById('1s')
        b1s.style.border = '';
        b1s.style.transform= 'scale(1) translateY(0px)';
        let b1m = document.getElementById('1m')
        b1m.style.border = '';
        b1m.style.transform= 'scale(1) translateY(0px)';
        let bcustom = document.getElementById('custom')
        bcustom.style.border = '2px solid mediumblue';
        bcustom.style.borderRadius = '5px';
        bcustom.style.transform= 'scale(1.2) translateY(-5px)'

      }
    }
  }

  openDatepicker(){
    this.pickerDirective.open();
  }

  updatedevType(devt){
    if(devt == 'Energia'){this.typeSelected = 'PM';this.formGroup.get('deviceSelectedPM').setValue([]);this.formGroup.get('telemSelected').setValue(["I1", "I2", "I3"]);};
    if(devt == 'Temperatura'){this.typeSelected = 'MT';this.formGroup.get('deviceSelectedMT').setValue([]);this.formGroup.get('telemSelected').setValue(['Temp']);};
    if(devt == 'I/O'){this.typeSelected = 'IO';this.formGroup.get('deviceSelectedIO').setValue([]);this.formGroup.get('telemSelected').setValue(['Out']);};
    if(devt == 'Gas'){this.typeSelected = 'Gas'};  
    if(devt == 'Diesel'){this.typeSelected = 'Diesel'};
    if(devt == 'Agua'){this.typeSelected = 'FlujoAgua'};
  }

  updatedevSelected(devt){
    console.log(devt);
    for(let id in this.PMDevs)
    {
      if(this.PMDevs[id]['id'] == devt)
      {
        console.log(this.PMDevs[id]['alias']);
        let zone = this.PMDevs[id]['alias'].split(' ')[0];
        let alias = this.PMDevs[id]['alias'].split(' ');
        alias.splice(0,1);
        console.log(alias);
        alias = alias.join(' ');
        
        let Zone = zone.split('/')[0];console.log(Zone);
        let city = zone.split('/')[1];
        let site = zone.split('/')[2];

        this.data.zone = Zone;
        this.data.city = city;
        this.data.office = site;
        this.alias = alias;
        this.delay(100).then(any =>{
          this.get_device_telemetry('');
        })

      }
    }
    for(let id in this.MTDevs){
      if(this.MTDevs[id]['id'] == devt)
      {
        console.log(this.MTDevs[id]['alias']);
        let zone = this.MTDevs[id]['alias'].split(' ')[0];
        let alias = this.MTDevs[id]['alias'].split(' ');
        alias.splice(0,1);
        console.log(alias);
        alias = alias.join(' ');
        
        let Zone = zone.split('/')[0];console.log(Zone);
        let city = zone.split('/')[1];
        let site = zone.split('/')[2];

        this.data.zone = Zone;
        this.data.city = city;
        this.data.office = site;
        this.alias = alias;
        this.delay(100).then(any =>{
          this.get_device_telemetry('');
        })

      }
    }

  }

  update_chart(chart, telem, ts?){
    var data = chart.dataTable;
    var header = chart.dataTable[0]; //copy of header
    var year = new Date().getFullYear();
    var month = new Date().getMonth();
    var day = new Date().getDate();
    var hour = new Date().getHours();
    var mins = new Date().getMinutes();
    var secs = new Date().getSeconds();
    var newts = new Date(year, month, day, hour, mins, secs);
    var payload = [];
    if(ts != null){var d = new Date(ts); payload.push(d);}else{payload.push(newts);}
    
    data = data.slice(0); // make copy
    data.splice(0, 1);
    ///agregar
    var i
    for(i=0; i<telem.length; i++){
      payload.push(parseFloat(telem[i]));
    }
    data.splice(data.length+1, 1, payload);
    //data.splice(0, 1);
    data.splice(0, 1, header); 
    console.log(data);
    chart.dataTable = data;
  }

  updateSelectedCount(count: number) {
    this.selectedCount = count;
  }

  redrawfunction(chart){
    let ccComponent = chart.component;
    let ccwrapper = ccComponent.wrapper;

    //redraw
    ccComponent.draw();
  }

  //Para imprimir
  justprint(){
    window.print();
 
   }

  printData()
  {
    this.snackBar.open('Generando Imagen para descargar....', '', {duration: 4000});
    domtoimage.toBlob(document.getElementById('chartArea'))
    .then(function (blob) {
       saveAs(blob, 'Historico-GentecView.png');
    });
  }

  openDatePicker(dp) {
    dp.open();
  }

  telemSelectorClose(event)
  {
    if(!event)
    {
      this.get_device_telemetry('');
    }
  }

  //funcion de delay
  async delay(ms: number) {
    await new Promise<void>(resolve => setTimeout(()=>resolve(), ms)).then(()=>console.log("T= ", ms));
  }

  compare(array1, array2) {
    if (array1.length != array2.length) {
      return false;
    }
  
    array1 = array1.slice();
    array1.sort();
    array2 = array2.slice();
    array2.sort();
  
    for (var i = 0; i < array1.length; i++) {
      if (array1[i] != array2[i]) {
        return false;
      }
    }
  
    return true;
  }

  downloadFile(data: any, device, zone, city, office, start, end) {
    const replacer = (key, value) => value === null ? '-' : value; // specify how you want to handle null values here
    const header = Object.keys(data[0]);
    let csv = data.map(row => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','));
    csv.unshift(header.join(','));
    csv[0] = this.formGroup.get("telemSelected").value
    csv[0].push('Fecha Hora');
    csv[0].push('Dispositivo: ' + device);
    csv[0].push('Lugar: ' + zone + '/' + city + '/' + office);
    let csvArray = csv.join('\r\n');
    
    
    var a = document.createElement('a');
    var blob = new Blob([csvArray], {type: 'text/csv' }),
    url = window.URL.createObjectURL(blob);

    var startDate = this.formGroup.get('date1').value.getFullYear() + '-' + ( '0' + (this.formGroup.get('date1').value.getMonth()+1)).slice(-2) + '-' + ('0' + this.formGroup.get('date1').value.getDate()).slice(-2) + ' 00:00:00';
            
    var endDate = this.formGroup.get('date2').value.getFullYear() + '-' + ( '0' + (this.formGroup.get('date2').value.getMonth()+1)).slice(-2) + '-' + ('0' + this.formGroup.get('date2').value.getDate()).slice(-2) + ' 23:59:00';


    a.href = url;
    a.download = "Consutlta-desde_"+startDate+"-hasta_"+endDate+".csv";
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
    
  }

  checkLabel(label){
    let name = label.split(' ');
    if(name[0] == 'Quito/Inaquito')
    {
      return true
    }
    else
    {
      return false
    }
  }

}

//------ Componente para confirmar borrado de widget.
@Component({
  selector: 'dialog-overview-confirm',
  templateUrl: 'dialog-overview-confirm.html',
  styleUrls: ['dialog-overview-confirm.css']
})
export class DialogOverviewConfirm {

  constructor(
    public dialogRef: MatDialogRef<DialogOverviewConfirm>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {}//console.log(data);

  onNoClick(): void {
    this.dialogRef.close();
  }

}

//----- Componente para editar o crear nuevo espacio.
@Component({
  selector: 'create-edit-space',
  templateUrl: 'create-edit-space.html',
  styleUrls: ['create-edit-space.css']
})
export class CreateEditSpace implements OnInit{
  public context: string;

  constructor(
    public dialogRef: MatDialogRef<DialogOverviewConfirm>,
    private formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {
      this.formGroup = this.formBuilder.group({
        spaceNameInput: new FormControl,
      })
    }

  //globales
  formGroup: FormGroup;
  onCreateClick(): void {
    this.dialogRef.close({ data: this.formGroup.get('spaceNameInput').value });
  }

  onEditClick(): void {
    this.dialogRef.close({ data: this.formGroup.get('spaceNameInput').value });
  }

  onNoClick(): void{
    this.dialogRef.close('ok');
  }

  ngOnInit(){
    this.context = this.data['context'];
  }

}

//----- Componente para ver o editar configuraciones de rangos de normalidad
@Component({
  selector: 'dialog-overview-alarms',
  templateUrl: 'dialog-overview-alarms.html',
  styleUrls: ['dialog-overview-alarms.css']
})
export class ViewEditAlarmsDialog implements OnInit{
  public context: string;
  public zone: string;                //zona seleccionada
  public city: string;                //ciudad seleccionada
  public office: string;              //sitio seleccionado
  public device: string;              //dispositivo seleccionado
  public alias: string;               //para ver alias
  public devType: string;             //para saber el tipo de dispositivo
  formGroup: FormGroup;

  //Variables para Temperatura
  public tempEnabled: boolean;
  public overTempMax;
  public overTempMin;

  //Variables para PM
  public COvLoF1;
  public COvLoF1_Enb: boolean;
  public COvLoF1_T;
  public COvLoF2;
  public COvLoF2_Enb: boolean;
  public COvLoF2_T;
  public COvLoF3;
  public COvLoF3_Enb: boolean;
  public COvLoF3_T;
  public FrOoR_Enb: boolean;
  public FrOoR_Max;
  public FrOoR_Min;
  public FrOoR_T;
  public NoVF1_Enb: boolean;
  public NoVF1_T;
  public NoVF2_Enb: boolean;
  public NoVF2_T;
  public NoVF3_Enb: boolean;
  public NoVF3_T;
  public VOoRF1_Enb: boolean;
  public VOoRF1_Max;
  public VOoRF1_Min;
  public VOoRF1_T;
  public VOoRF2_Enb: boolean;
  public VOoRF2_Max;
  public VOoRF2_Min;
  public VOoRF2_T;
  public VOoRF3_Enb: boolean;
  public VOoRF3_Max;
  public VOoRF3_Min;
  public VOoRF3_T;
  public VOoRF12_Enb: boolean;
  public VOoRF12_Max;
  public VOoRF12_Min;
  public VOoRF12_T;
  public VOoRF23_Enb: boolean;
  public VOoRF23_Max;
  public VOoRF23_Min;
  public VOoRF23_T;
  public VOoRF31_Enb: boolean;
  public VOoRF31_Max;
  public VOoRF31_Min;
  public VOoRF31_T;
  

  onNoClick(): void {
    this.dialogRef.close('done');
  }

  constructor(
    public dialogRef: MatDialogRef<DialogOverviewConfirm>,
    private alarms: AlarmsqueryService,
    private formBuilder: FormBuilder,
    private snack: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {
      this.formGroup = this.formBuilder.group({
        spaceNameInput: new FormControl,
      })
    }

  ngOnInit(){
    this.devType = this.data['devtype']
    this.alias = this.data['alias'];

    if(this.devType == 'MT')
    {
      let id = this.data['zone']+'-'+this.data['city']+'-'+this.data['office'];
      let devName = this.data['name']
      let s = this.alarms.getAlarmsConfig(id).subscribe(result =>{
        if(result != undefined)
        {
          let found = false;
          if(result['devices']['MT'] != undefined)
          {
            for(let i in result['devices']['MT'])
            {
              if(result['devices']['MT'][i]['name'] == devName)
              {
                if(result['devices']['MT'][i]['configs'] != undefined)
                {
                  found = true;
                  console.log(result['devices']['MT'][i]);
                  this.overTempMax = result['devices']['MT'][i]['configs']['overTempMax'];
                  this.overTempMin = result['devices']['MT'][i]['configs']['overTempMin'];
                  this.tempEnabled = result['devices']['MT'][i]['configs']['overTemp_Enb'];
                }                
              }
            }
            if(!found)
            {
              this.overTempMax = 0;
              this.overTempMin = 0;
              this.tempEnabled = false;
              this.snack.open('Dispositivo no tiene una configuracion asignada','x', {duration: 2000} );
            }
          }
          else
          {
            this.overTempMax = 0;
            this.overTempMin = 0;
            this.tempEnabled = false;
            this.snack.open('Dispositivo no tiene una configuracion asignada','x', {duration: 2000} );
          }
        }
        else
        {
          this.overTempMax = 0;
          this.overTempMin = 0;
          this.tempEnabled = false;
          this.snack.open('Dispositivo no tiene una configuracion asignada','x', {duration: 2000} );
        }
        s.unsubscribe();
      })
    }
    if(this.devType == 'PM')
    {
      let id = this.data['zone']+'-'+this.data['city']+'-'+this.data['office'];
      let devName = this.data['name']
      let s = this.alarms.getAlarmsConfig(id).subscribe(result =>{
        if(result != undefined)
        {
          let found = false;
          if(result['devices']['PM'] != undefined)
          {
            for(let i in result['devices']['PM'])
            {
              if(result['devices']['PM'][i]['name'] == devName)
              {
                if(result['devices']['PM'][i]['configs'] != undefined)
                {
                  found = true;
                  console.log(result['devices']['PM'][i]);
                  //corriente fuera de rango
                  this.COvLoF1 = result['devices']['PM'][i]['configs']['COvLoF1'];
                  this.COvLoF1_Enb = result['devices']['PM'][i]['configs']['COvLoF1_Enb'];
                  this.COvLoF2 = result['devices']['PM'][i]['configs']['COvLoF2'];
                  this.COvLoF2_Enb = result['devices']['PM'][i]['configs']['COvLoF2_Enb'];
                  this.COvLoF3 = result['devices']['PM'][i]['configs']['COvLoF3'];
                  this.COvLoF3_Enb = result['devices']['PM'][i]['configs']['COvLoF3_Enb'];
                  //voltajes fuera de rango
                  this.VOoRF1_Max = result['devices']['PM'][i]['configs']['VOoRF1_Max'];
                  this.VOoRF1_Min = result['devices']['PM'][i]['configs']['VOoRF1_Min'];
                  this.VOoRF1_Enb = result['devices']['PM'][i]['configs']['VOoRF1_Enb'];
                  this.VOoRF2_Max = result['devices']['PM'][i]['configs']['VOoRF2_Max'];
                  this.VOoRF2_Min = result['devices']['PM'][i]['configs']['VOoRF2_Min'];
                  this.VOoRF2_Enb = result['devices']['PM'][i]['configs']['VOoRF2_Enb'];
                  this.VOoRF3_Max = result['devices']['PM'][i]['configs']['VOoRF3_Max'];
                  this.VOoRF3_Min = result['devices']['PM'][i]['configs']['VOoRF3_Min'];
                  this.VOoRF3_Enb = result['devices']['PM'][i]['configs']['VOoRF3_Enb'];
                  //voltajes v-v fuera de rango
                  this.VOoRF12_Max = result['devices']['PM'][i]['configs']['VOoRF12_Max'];
                  this.VOoRF12_Min = result['devices']['PM'][i]['configs']['VOoRF12_Min'];
                  this.VOoRF12_Enb = result['devices']['PM'][i]['configs']['VOoRF12_Enb'];
                  this.VOoRF23_Max = result['devices']['PM'][i]['configs']['VOoRF23_Max'];
                  this.VOoRF23_Min = result['devices']['PM'][i]['configs']['VOoRF23_Min'];
                  this.VOoRF23_Enb = result['devices']['PM'][i]['configs']['VOoRF23_Enb'];
                  this.VOoRF31_Max = result['devices']['PM'][i]['configs']['VOoRF31_Max'];
                  this.VOoRF31_Min = result['devices']['PM'][i]['configs']['VOoRF31_Min'];
                  this.VOoRF31_Enb = result['devices']['PM'][i]['configs']['VOoRF31_Enb'];
                  //frecuencia fuera de rango
                  this.FrOoR_Max = result['devices']['PM'][i]['configs']['FrOoR_Max'];
                  this.FrOoR_Min = result['devices']['PM'][i]['configs']['FrOoR_Min'];
                  this.FrOoR_Enb = result['devices']['PM'][i]['configs']['FrOoR_Enb'];
                  //Ausencia de voltajes
                  this.NoVF1_Enb = result['devices']['PM'][i]['configs']['NoVF1_Enb'];
                  this.NoVF2_Enb = result['devices']['PM'][i]['configs']['NoVF2_Enb'];
                  this.NoVF3_Enb = result['devices']['PM'][i]['configs']['NoVF3_Enb'];

                }                
              }
            }
            if(!found)
            {
              this.COvLoF1 = 0;
              this.COvLoF1_Enb = false;
              this.COvLoF2 = 0;
              this.COvLoF2_Enb = false;
              this.COvLoF3 = 0;
              this.COvLoF3_Enb = false;
              //voltajes fuera de rango
              this.VOoRF1_Max = 0;
              this.VOoRF1_Min = 0;
              this.VOoRF1_Enb = false;
              this.VOoRF2_Max = 0;
              this.VOoRF2_Min = 0;
              this.VOoRF2_Enb = false;
              this.VOoRF3_Max = 0;
              this.VOoRF3_Min = 0;
              this.VOoRF3_Enb = false;
              //voltajes v-v fuera de rango
              this.VOoRF12_Max = 0;
              this.VOoRF12_Min = 0;
              this.VOoRF12_Enb = false;
              this.VOoRF23_Max = 0;
              this.VOoRF23_Min = 0;
              this.VOoRF23_Enb = false;
              this.VOoRF31_Max = 0;
              this.VOoRF31_Min = 0;
              this.VOoRF31_Enb = false;
              //frecuencia fuera de rango
              this.FrOoR_Max = 0;
              this.FrOoR_Min = 0;
              this.FrOoR_Enb = false;
              //Ausencia de voltajes
              this.NoVF1_Enb = false;
              this.NoVF2_Enb = false;
              this.NoVF3_Enb = false;
              this.snack.open('Dispositivo no tiene una configuracion asignada','x', {duration: 2000} );
            }
          }
          else
          {
            this.COvLoF1 = 0;
            this.COvLoF1_Enb = false;
            this.COvLoF2 = 0;
            this.COvLoF2_Enb = false;
            this.COvLoF3 = 0;
            this.COvLoF3_Enb = false;
            //voltajes fuera de rango
            this.VOoRF1_Max = 0;
            this.VOoRF1_Min = 0;
            this.VOoRF1_Enb = false;
            this.VOoRF2_Max = 0;
            this.VOoRF2_Min = 0;
            this.VOoRF2_Enb = false;
            this.VOoRF3_Max = 0;
            this.VOoRF3_Min = 0;
            this.VOoRF3_Enb = false;
            //voltajes v-v fuera de rango
            this.VOoRF12_Max = 0;
            this.VOoRF12_Min = 0;
            this.VOoRF12_Enb = false;
            this.VOoRF23_Max = 0;
            this.VOoRF23_Min = 0;
            this.VOoRF23_Enb = false;
            this.VOoRF31_Max = 0;
            this.VOoRF31_Min = 0;
            this.VOoRF31_Enb = false;
            //frecuencia fuera de rango
            this.FrOoR_Max = 0;
            this.FrOoR_Min = 0;
            this.FrOoR_Enb = false;
            //Ausencia de voltajes
            this.NoVF1_Enb = false;
            this.NoVF2_Enb = false;
            this.NoVF3_Enb = false;
            this.snack.open('Dispositivo no tiene una configuracion asignada','x', {duration: 2000} );
          }
        }
        else
        {
          this.COvLoF1 = 0;
          this.COvLoF1_Enb = false;
          this.COvLoF2 = 0;
          this.COvLoF2_Enb = false;
          this.COvLoF3 = 0;
          this.COvLoF3_Enb = false;
          //voltajes fuera de rango
          this.VOoRF1_Max = 0;
          this.VOoRF1_Min = 0;
          this.VOoRF1_Enb = false;
          this.VOoRF2_Max = 0;
          this.VOoRF2_Min = 0;
          this.VOoRF2_Enb = false;
          this.VOoRF3_Max = 0;
          this.VOoRF3_Min = 0;
          this.VOoRF3_Enb = false;
          //voltajes v-v fuera de rango
          this.VOoRF12_Max = 0;
          this.VOoRF12_Min = 0;
          this.VOoRF12_Enb = false;
          this.VOoRF23_Max = 0;
          this.VOoRF23_Min = 0;
          this.VOoRF23_Enb = false;
          this.VOoRF31_Max = 0;
          this.VOoRF31_Min = 0;
          this.VOoRF31_Enb = false;
          //frecuencia fuera de rango
          this.FrOoR_Max = 0;
          this.FrOoR_Min = 0;
          this.FrOoR_Enb = false;
          //Ausencia de voltajes
          this.NoVF1_Enb = false;
          this.NoVF2_Enb = false;
          this.NoVF3_Enb = false;
          this.snack.open('Dispositivo no tiene una configuracion asignada','x', {duration: 2000} );
        }
        s.unsubscribe();
      })
    }
  }
}
